// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Premium empty state (data tables / views) ── */
@keyframes skEmptyFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}
@keyframes skEmptyRing {
  0% { transform: scale(0.85); opacity: 0.5; }
  70% { transform: scale(1.5); opacity: 0; }
  100% { transform: scale(1.5); opacity: 0; }
}
@keyframes skSparkle {
  0%, 100% { opacity: 0; transform: scale(0.6); }
  50% { opacity: 1; transform: scale(1); }
}
@keyframes skGlowPulse {
  0%, 100% { opacity: 0.5; transform: translateX(-50%) scale(1); }
  50% { opacity: 0.9; transform: translateX(-50%) scale(1.15); }
}
@keyframes skEmptySheen {
  0%   { transform: translateX(-130%) skewX(-18deg); }
  55%, 100% { transform: translateX(240%) skewX(-18deg); }
}
.sk-empty {
  position: relative;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  text-align: center;
  width: 100%; max-width: 460px;
  margin: 44px auto;
  padding: 54px 40px 50px; gap: 9px;
  border-radius: 22px;
  background:
    radial-gradient(120% 78% at 50% -12%, var(--accent-soft), transparent 62%),
    linear-gradient(180deg, var(--card), var(--paper-2));
  border: 1px solid var(--accent-line);
  box-shadow: var(--shadow-lg), inset 0 1px 0 rgba(255,255,255,0.5);
  overflow: hidden;
  animation: skFadeUp .55s cubic-bezier(.2,.7,.3,1) both;
}
/* Diagonal light sheen that periodically sweeps across the card */
.sk-empty::after {
  content: '';
  position: absolute; top: 0; left: 0; width: 55%; height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.16), transparent);
  transform: translateX(-130%) skewX(-18deg);
  animation: skEmptySheen 6s ease-in-out 0.8s infinite;
  pointer-events: none;
}
/* Soft radial glow behind the icon badge */
.sk-empty::before {
  content: '';
  position: absolute; top: 26px; left: 50%; width: 200px; height: 200px;
  transform: translateX(-50%);
  background: radial-gradient(circle, rgba(99,102,241,0.18), rgba(99,102,241,0) 70%);
  pointer-events: none;
  animation: skGlowPulse 4s ease-in-out infinite;
}
.sk-empty-icon {
  position: relative;
  width: 76px; height: 76px; border-radius: 50%;
  display: grid; place-items: center;
  background: radial-gradient(circle at 32% 26%, var(--accent-soft), var(--accent-line));
  border: 1px solid var(--accent-line);
  box-shadow: 0 16px 30px -12px rgba(79,70,229,0.50), 0 4px 10px -4px rgba(79,70,229,0.30), inset 0 1px 0 rgba(255,255,255,0.7);
  margin-bottom: 10px;
  animation: skEmptyFloat 3.4s ease-in-out infinite;
}
/* Two expanding halo rings → a ripple */
.sk-empty-icon::before,
.sk-empty-icon::after {
  content: '';
  position: absolute; inset: -6px; border-radius: 50%;
  border: 1.5px solid var(--accent);
  animation: skEmptyRing 2.8s ease-out infinite;
}
.sk-empty-icon::after { animation-delay: 1.4s; }
/* Floating sparkles around the badge */
.sk-empty-icon > svg { position: relative; z-index: 1; }
.sk-empty-title {
  position: relative;
  font-size: 19px; font-weight: var(--fw-bold); letter-spacing: -0.4px;
  margin-top: 2px;
  background: linear-gradient(120deg, var(--ink), var(--accent-ink));
  -webkit-background-clip: text; background-clip: text;
  -webkit-text-fill-color: transparent; color: var(--accent-ink);
}
.sk-empty-sub {
  position: relative;
  font-size: 13.5px; color: var(--ink-3); max-width: 360px;
  text-align: center; line-height: 20px; margin-top: 1px;
}
/* Decorative sparkles */
.sk-empty-title::before,
.sk-empty-title::after {
  content: '✦';
  position: absolute; top: -34px;
  color: var(--accent); opacity: 0;
  font-size: 11px;
  animation: skSparkle 2.4s ease-in-out infinite;
  -webkit-text-fill-color: var(--accent);
}
.sk-empty-title::before { left: 18%; animation-delay: 0.3s; font-size: 13px; }
.sk-empty-title::after { right: 16%; top: -52px; animation-delay: 1.1s; }

/* ════════════════════════════════════════════
   COMING SOON — premium animated placeholder card
   ════════════════════════════════════════════ */
@keyframes skComingIn { 0% { opacity: 0; transform: translateY(20px) scale(0.97); } 100% { opacity: 1; transform: none; } }
@keyframes skComingFloat { 0%, 100% { transform: translateY(0) rotate(-8deg); } 50% { transform: translateY(-8px) rotate(-8deg); } }
@keyframes skComingHalo { 0% { transform: scale(0.8); opacity: 0.55; } 70% { transform: scale(1.6); opacity: 0; } 100% { opacity: 0; } }
@keyframes skComingGlow { 0%, 100% { opacity: 0.55; transform: translateX(-50%) scale(1); } 50% { opacity: 0.95; transform: translateX(-50%) scale(1.18); } }
@keyframes skComingSparkle { 0%, 100% { opacity: 0; transform: scale(0.5); } 50% { opacity: 1; transform: scale(1); } }

.sk-coming {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  background:
    radial-gradient(900px 360px at 50% -10%, var(--accent-soft), transparent 70%),
    var(--paper-2);
  overflow: hidden;
}
/* Drifting aurora blobs behind the card */
@keyframes skDrift1 { 0%, 100% { transform: translate(0, 0); } 50% { transform: translate(46px, -34px); } }
@keyframes skDrift2 { 0%, 100% { transform: translate(0, 0); } 50% { transform: translate(-44px, 32px); } }
.sk-coming::before, .sk-coming::after {
  content: ''; position: absolute; border-radius: 50%; pointer-events: none;
  filter: blur(26px);
}
.sk-coming::before {
  width: 400px; height: 400px; top: -90px; left: 8%;
  background: radial-gradient(circle, rgba(99,102,241,0.20), transparent 70%);
  animation: skDrift1 9s ease-in-out infinite;
}
.sk-coming::after {
  width: 340px; height: 340px; bottom: -70px; right: 6%;
  background: radial-gradient(circle, rgba(14,165,233,0.16), transparent 70%);
  animation: skDrift2 11s ease-in-out infinite;
}
.sk-coming-card {
  position: relative;
  width: 100%;
  max-width: 520px;
  text-align: center;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--r-5);
  padding: 48px 36px 40px;
  box-shadow: 0 24px 60px -24px rgba(16,24,40,0.28), 0 4px 14px rgba(16,24,40,0.06);
  animation: skComingIn .6s cubic-bezier(.2,.7,.3,1) both;
  overflow: hidden;
}
/* Rotating gradient border around the card */
.sk-coming-card::before {
  content: ''; position: absolute; inset: 0; border-radius: inherit; padding: 1.5px;
  background: conic-gradient(from 0deg, var(--accent), #6366f1, transparent 38%, transparent 62%, var(--accent));
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor; mask-composite: exclude;
  opacity: 0.55; pointer-events: none;
  animation: skComingSpin 8s linear infinite;
}
.sk-coming-glow {
  position: absolute; top: 12px; left: 50%; width: 280px; height: 280px;
  transform: translateX(-50%);
  background: radial-gradient(circle, rgba(99,102,241,0.20), rgba(99,102,241,0) 70%);
  pointer-events: none;
  animation: skComingGlow 4.2s ease-in-out infinite;
}
.sk-coming-icon {
  position: relative;
  width: 80px; height: 80px; border-radius: 22px;
  margin: 0 auto 22px;
  display: grid; place-items: center;
  background: radial-gradient(circle at 30% 24%, #eef2ff, #e0e7ff);
  border: 1px solid var(--accent-line);
  box-shadow: 0 14px 30px -12px rgba(79,70,229,0.5), inset 0 1px 0 rgba(255,255,255,0.7);
  animation: skComingFloat 3.6s ease-in-out infinite;
}
.sk-coming-icon::before,
.sk-coming-icon::after {
  content: ''; position: absolute; inset: -6px; border-radius: 24px;
  border: 1.5px solid var(--accent);
  animation: skComingHalo 2.8s ease-out infinite;
}
.sk-coming-icon::after { animation-delay: 1.4s; }
.sk-coming-eyebrow {
  font-size: 11px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase;
  color: var(--accent); margin-bottom: 8px;
}
.sk-coming-title {
  position: relative;
  font-size: 26px; font-weight: 800; letter-spacing: -0.6px;
  background: linear-gradient(120deg, var(--ink), var(--accent));
  -webkit-background-clip: text; background-clip: text;
  -webkit-text-fill-color: transparent; color: var(--accent-ink);
}
.sk-coming-title::before, .sk-coming-title::after {
  content: '✦'; position: absolute; color: var(--accent);
  -webkit-text-fill-color: var(--accent); opacity: 0; font-size: 12px;
  animation: skComingSparkle 2.4s ease-in-out infinite;
}
.sk-coming-title::before { top: -16px; left: 22%; animation-delay: .2s; }
.sk-coming-title::after { top: -26px; right: 20%; font-size: 15px; animation-delay: 1.1s; }
.sk-coming-sub {
  font-size: 14px; color: var(--ink-3); line-height: 21px;
  max-width: 380px; margin: 12px auto 0;
}
.sk-coming-chip {
  display: inline-block; margin-top: 8px;
  font-size: 12.5px; font-weight: 600; color: var(--accent-ink);
  background: var(--accent-soft); border: 1px solid var(--accent-line);
  border-radius: 999px; padding: 7px 16px;
}

/* Light sheen sweeping across the card on entrance */
@keyframes skComingSheen { 0% { left: -60%; } 65%, 100% { left: 150%; } }
.sk-coming-card::after {
  content: ''; position: absolute; top: 0; bottom: 0; left: -60%; width: 40%;
  background: linear-gradient(105deg, transparent, rgba(99,102,241,0.10), transparent);
  transform: skewX(-16deg); pointer-events: none;
  animation: skComingSheen 1.8s ease .3s both;
}

/* Slowly rotating gradient ring behind the icon */
@keyframes skComingSpin { to { transform: rotate(360deg); } }
.sk-coming-spin {
  position: absolute; inset: -5px; border-radius: 26px;
  background: conic-gradient(from 0deg, transparent, var(--accent) 90deg, transparent 200deg, var(--accent) 320deg, transparent);
  opacity: 0.35;
  animation: skComingSpin 6s linear infinite;
  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px));
  mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px));
}

/* "Building" shimmer progress bar */
@keyframes skComingShimmer { 0% { transform: translateX(-100%); } 100% { transform: translateX(320%); } }
.sk-coming-bar {
  position: relative; width: 180px; height: 6px; margin: 22px auto 0;
  border-radius: 999px; background: var(--paper-3); overflow: hidden;
}
.sk-coming-bar-fill {
  position: absolute; top: 0; bottom: 0; left: 0; width: 38%;
  border-radius: 999px;
  background: linear-gradient(90deg, transparent, var(--accent), #6366f1, transparent);
  animation: skComingShimmer 1.8s ease-in-out infinite;
}

/* ── Row action icon buttons (edit / delete in data tables) ── */
.sk-row-act {
  display: inline-grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  border: 1px solid var(--line);
  background: var(--card);
  color: var(--ink-3);
  cursor: pointer;
  box-shadow: var(--shadow-sm);
  transition: background 130ms ease, color 130ms ease, border-color 130ms ease, transform 130ms ease, box-shadow 130ms ease;
}
.sk-row-act:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow);
}
.sk-row-act:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}
/* Edit → indigo accent on hover */
.sk-row-act--edit:hover {
  background: var(--accent-soft);
  border-color: var(--accent-line);
  color: var(--accent);
}
/* Delete → danger red on hover */
.sk-row-act--danger:hover {
  background: var(--danger-soft);
  border-color: var(--danger-line);
  color: var(--danger);
}
/* ── Dialog field labels (icon-led) ── */
.sk-dlg-label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 7px;
  font-size: 12px;
  font-weight: var(--fw-semibold);
  color: var(--ink-2);
}
/* ── Dialog text inputs (edit cards) ── */
.sk-dlg-input {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--line-strong);
  border-radius: var(--r-3);
  padding: 9px 12px;
  font-size: var(--fs-md);
  color: var(--ink);
  background: var(--card);
  outline: none;
  box-shadow: inset 0 1px 2px rgba(16,24,40,0.04);
}

/* ── Premium focus on bordered inputs (modals/forms). No box-shadow ring so
   borderless inputs like the search field don't get a "box inside a box". ── */
input:focus,
textarea:focus {
  border-color: var(--accent) !important;
}

/* ── Global premium scrollbars — visible + styled across the app ── */
* {
  scrollbar-width: thin;
  scrollbar-color: var(--line-strong, #ccccc4) transparent;
}
*::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
*::-webkit-scrollbar-track {
  background: transparent;
}
*::-webkit-scrollbar-thumb {
  background: var(--line-strong, #ccccc4);
  border-radius: 999px;
  border: 2px solid transparent;
  background-clip: padding-box;
}
*::-webkit-scrollbar-thumb:hover {
  background: var(--ink-4, #9999aa);
  background-clip: padding-box;
}

:root {
  --font-sans: "IBM Plex Sans", "Inter", "Helvetica Neue", Helvetica, Arial, sans-serif;
  --font-mono: "IBM Plex Mono", ui-monospace, "JetBrains Mono", Menlo, monospace;
  --fs-xs: 11px;
  --fs-sm: 12px;
  --fs-md: 13px;
  --fs-lg: 15px;
  --fs-xl: 18px;
  --fs-2xl: 22px;
  --fs-3xl: 28px;
  --fw-regular: 400;
  --fw-medium: 500;
  --fw-semibold: 600;
  --fw-bold: 700;

  --paper: oklch(0.985 0.003 90);
  --paper-2: oklch(0.970 0.004 90);
  --paper-3: oklch(0.955 0.005 90);
  --card: #ffffff;

  --ink: oklch(0.20 0.010 250);
  --ink-2: oklch(0.38 0.010 250);
  --ink-3: oklch(0.55 0.010 250);
  --ink-4: oklch(0.72 0.008 250);
  --line: oklch(0.92 0.004 250);
  --line-strong: oklch(0.85 0.005 250);

  --accent: oklch(0.52 0.16 260);
  --accent-ink: oklch(0.35 0.14 260);
  --accent-soft: oklch(0.96 0.03 260);
  --accent-line: oklch(0.86 0.06 260);

  --info: oklch(0.55 0.15 250);
  --info-soft: oklch(0.96 0.04 250);
  --info-line: color-mix(in oklab, var(--info) 30%, var(--line));

  --success: oklch(0.50 0.14 150);
  --success-soft: oklch(0.95 0.05 150);
  --success-line: color-mix(in oklab, var(--success) 30%, var(--line));

  --warn: oklch(0.62 0.13 60);
  --warn-soft: oklch(0.96 0.06 80);
  --warn-line: color-mix(in oklab, var(--warn) 30%, var(--line));

  --danger: oklch(0.55 0.13 25);
  --danger-soft: oklch(0.96 0.04 25);
  --danger-line: color-mix(in oklab, var(--danger) 30%, var(--line));

  --neutral: oklch(0.55 0.14 200);
  --neutral-soft: oklch(0.96 0.04 200);
  --neutral-line: color-mix(in oklab, var(--neutral) 30%, var(--line));

  --r-1: 3px;
  --r-2: 5px;
  --r-3: 8px;
  --r-4: 12px;
  --r-5: 16px;
  --r-full: 999px;

  --shadow-sm: 0 1px 0 rgba(16, 24, 40, .04);
  --shadow: 0 1px 2px rgba(16, 24, 40, .06), 0 4px 12px -4px rgba(16, 24, 40, .08);
  --shadow-md: 0 2px 6px rgba(16, 24, 40, .08), 0 8px 20px -6px rgba(16, 24, 40, .10);
  --shadow-lg: 0 4px 14px rgba(16, 24, 40, .10), 0 16px 32px -12px rgba(16, 24, 40, .14);
  --shadow-focus: 0 0 0 3px var(--accent-soft);

  --t-fast: 100ms;
  --t-base: 180ms;
  --ease-out: cubic-bezier(.2, .8, .2, 1);
}

/* ─── Dark mode ────────────────────────────────────────────────────────────
   Token-only override. Every surface/text/accent variable is re-pointed so the
   whole token-driven UI recolors with no per-component changes. Toggled via the
   sidebar "Appearance" switch, which sets data-theme="dark" on <html>. */
:root[data-theme="dark"] {
  --paper:   oklch(0.17 0.012 265);
  --paper-2: oklch(0.21 0.014 265);
  --paper-3: oklch(0.25 0.016 265);
  --card:    oklch(0.205 0.015 265);

  --ink:   oklch(0.96 0.006 265);
  --ink-2: oklch(0.83 0.010 265);
  --ink-3: oklch(0.67 0.012 265);
  --ink-4: oklch(0.54 0.012 265);
  --line:        oklch(0.32 0.014 265);
  --line-strong: oklch(0.42 0.016 265);

  --accent:      oklch(0.72 0.15 265);
  --accent-ink:  oklch(0.86 0.10 265);
  --accent-soft: oklch(0.30 0.07 265);
  --accent-line: oklch(0.44 0.09 265);

  --info:      oklch(0.72 0.13 250);
  --info-soft: oklch(0.30 0.06 250);

  --success:      oklch(0.72 0.13 150);
  --success-soft: oklch(0.30 0.06 150);

  --warn:      oklch(0.80 0.12 75);
  --warn-soft: oklch(0.32 0.06 70);

  --danger:      oklch(0.72 0.14 25);
  --danger-soft: oklch(0.32 0.07 25);

  --neutral:      oklch(0.72 0.11 200);
  --neutral-soft: oklch(0.30 0.05 200);

  /* INTERNAL partition (teal) — brighten the accent, darken the soft fills. */
  --internal:      oklch(0.72 0.11 215);
  --internal-ink:  oklch(0.84 0.09 215);
  --internal-soft: oklch(0.30 0.05 215);
  --internal-mute: oklch(0.35 0.06 215);
  --internal-line: oklch(0.44 0.07 215);

  /* Shadows need black + higher alpha to read on dark surfaces. */
  --shadow-sm: 0 1px 0 rgba(0, 0, 0, .30);
  --shadow:    0 1px 2px rgba(0, 0, 0, .40), 0 4px 12px -4px rgba(0, 0, 0, .55);
  --shadow-md: 0 2px 6px rgba(0, 0, 0, .45), 0 8px 20px -6px rgba(0, 0, 0, .60);
  --shadow-lg: 0 4px 14px rgba(0, 0, 0, .50), 0 16px 32px -12px rgba(0, 0, 0, .70);
  --shadow-focus: 0 0 0 3px var(--accent-soft);

  color-scheme: dark;
}

/* Sidebar's inner light edge looks wrong on dark — neutralize it. */
:root[data-theme="dark"] .sk-sidebar {
  box-shadow: 1px 0 0 rgba(0, 0, 0, 0.2), inset -1px 0 0 rgba(255, 255, 255, 0.03);
}

/* Smooth the recolor when toggling. */
body,
.sk-sidebar,
.sk-card,
.sk-topbar {
  transition: background-color var(--t-base) var(--ease-out),
    border-color var(--t-base) var(--ease-out),
    color var(--t-base) var(--ease-out);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body,
#root {
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  font-family: var(--font-sans);
  font-size: var(--fs-md);
  line-height: 1.45;
  color: var(--ink);
  background: var(--paper);
  -webkit-font-smoothing: antialiased;
}

button {
  font: inherit;
  cursor: pointer;
}

input,
select,
textarea {
  font: inherit;
  color: inherit;
}

.t-mono {
  font-family: var(--font-mono);
  font-feature-settings: "ss01";
}

.t-dim {
  color: var(--ink-3);
}

.t-strong {
  color: var(--ink);
  font-weight: var(--fw-semibold);
}

.t-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Buttons ── */
.t-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px;
  border-radius: var(--r-2);
  border: 1px solid var(--line);
  background: var(--card);
  color: var(--ink);
  font-size: var(--fs-md);
  font-weight: var(--fw-medium);
  white-space: nowrap;
  user-select: none;
  transition: background var(--t-fast) var(--ease-out), border-color var(--t-fast) var(--ease-out), color var(--t-fast) var(--ease-out);
  cursor: pointer;
}

.t-btn:hover {
  background: var(--paper-2);
}

.t-btn:active {
  transform: translateY(0.5px);
}

.t-btn:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
}

.t-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.t-btn--primary {
  background: var(--ink);
  color: var(--paper);
  border-color: var(--ink);
}

.t-btn--primary:hover {
  background: color-mix(in oklab, var(--ink) 88%, white);
}

.t-btn--accent {
  background: var(--accent);
  color: #fff;
  border-color: var(--accent);
}

.t-btn--accent:hover {
  background: var(--accent-ink);
  border-color: var(--accent-ink);
}

.t-btn--danger {
  background: var(--danger);
  color: #fff;
  border-color: var(--danger);
}

.t-btn--ghost {
  background: transparent;
  border-color: transparent;
  color: var(--ink-2);
}

.t-btn--ghost:hover {
  background: color-mix(in oklab, var(--ink) 6%, transparent);
  color: var(--ink);
}

.t-btn--outline {
  background: transparent;
}

.t-btn--sm {
  height: 26px;
  padding: 0 10px;
  font-size: var(--fs-sm);
}

.t-btn--xs {
  height: 22px;
  padding: 0 8px;
  font-size: var(--fs-xs);
}

.t-btn--lg {
  height: 38px;
  padding: 0 18px;
  font-size: var(--fs-lg);
}

.t-btn--icon {
  padding: 0;
  width: 32px;
}

.t-btn--icon.t-btn--sm {
  width: 26px;
}

.t-btn--icon.t-btn--xs {
  width: 22px;
}

/* ── Inputs ── */
.t-input {
  display: block;
  width: 100%;
  height: 34px;
  padding: 0 12px;
  border: 1px solid var(--line);
  background: var(--card);
  border-radius: var(--r-2);
  font-size: var(--fs-md);
  color: var(--ink);
  outline: none;
  transition: border-color var(--t-fast), box-shadow var(--t-fast);
}

.t-input::placeholder {
  color: var(--ink-4);
}

.t-input:hover {
  border-color: var(--line-strong);
}

.t-input:focus {
  border-color: var(--accent);
  box-shadow: var(--shadow-focus);
}

textarea.t-input {
  height: auto;
  padding: 8px 12px;
  min-height: 80px;
  resize: vertical;
  line-height: 1.5;
}

.t-input--sm {
  height: 28px;
  font-size: var(--fs-sm);
  padding: 0 10px;
}

/* ── Fields ── */
.t-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.t-field label {
  font-size: var(--fs-sm);
  color: var(--ink-2);
  font-weight: var(--fw-medium);
}

.t-field-hint {
  font-size: var(--fs-xs);
  color: var(--ink-3);
}

.t-field-error {
  font-size: var(--fs-xs);
  color: var(--danger);
}

/* ── Switch ── */
.t-switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  font-size: var(--fs-sm);
  color: var(--ink-2);
}

.t-switch input {
  display: none;
}

.t-switch-track {
  width: 32px;
  height: 18px;
  background: var(--paper-3);
  border: 1px solid var(--line-strong);
  border-radius: var(--r-full);
  position: relative;
  transition: background var(--t-base), border-color var(--t-base);
  flex-shrink: 0;
}

.t-switch-track::after {
  content: "";
  position: absolute;
  top: 1px;
  left: 1px;
  width: 14px;
  height: 14px;
  background: var(--card);
  border-radius: 50%;
  box-shadow: 0 1px 2px rgba(16, 24, 40, .18);
  transition: transform var(--t-base) var(--ease-out);
}

.t-switch input:checked+.t-switch-track {
  background: var(--accent);
  border-color: var(--accent);
}

.t-switch input:checked+.t-switch-track::after {
  transform: translateX(14px);
}

/* ── Cards ── */
.t-card {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--r-3);
  box-shadow: var(--shadow-sm);
}

.t-card-head {
  padding: 12px 16px;
  border-bottom: 1px solid var(--line);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.t-card-head h3 {
  margin: 0;
  font-size: var(--fs-md);
  font-weight: var(--fw-semibold);
}

.t-card-sub {
  color: var(--ink-3);
  font-size: var(--fs-sm);
}

.t-card-body {
  padding: 16px;
}

.t-card-foot {
  padding: 12px 16px;
  border-top: 1px solid var(--line);
  background: var(--paper-2);
  border-radius: 0 0 var(--r-3) var(--r-3);
  font-size: var(--fs-sm);
  color: var(--ink-3);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* ── Chips ── */
.t-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 22px;
  padding: 0 9px;
  border-radius: var(--r-full);
  border: 1px solid var(--line);
  background: var(--card);
  font-size: var(--fs-xs);
  font-weight: var(--fw-medium);
  color: var(--ink-2);
  white-space: nowrap;
}

.t-chip--lg {
  height: 26px;
  padding: 0 12px;
  font-size: var(--fs-sm);
}

.t-chip-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--ink-3);
  flex-shrink: 0;
}

.t-chip--info {
  color: var(--info);
  background: var(--info-soft);
  border-color: var(--info-line);
}

.t-chip--info .t-chip-dot {
  background: var(--info);
}

.t-chip--success {
  color: var(--success);
  background: var(--success-soft);
  border-color: var(--success-line);
}

.t-chip--success .t-chip-dot {
  background: var(--success);
}

.t-chip--warn {
  color: var(--warn);
  background: var(--warn-soft);
  border-color: var(--warn-line);
}

.t-chip--warn .t-chip-dot {
  background: var(--warn);
}

.t-chip--danger {
  color: var(--danger);
  background: var(--danger-soft);
  border-color: var(--danger-line);
}

.t-chip--danger .t-chip-dot {
  background: var(--danger);
}

.t-chip--neutral {
  color: var(--neutral);
  background: var(--neutral-soft);
  border-color: var(--neutral-line);
}

.t-chip--neutral .t-chip-dot {
  background: var(--neutral);
}

.t-chip--accent {
  color: var(--accent-ink);
  background: var(--accent-soft);
  border-color: var(--accent-line);
}

.t-chip--accent .t-chip-dot {
  background: var(--accent);
}

.t-chip--solid {
  background: var(--ink);
  color: var(--paper);
  border-color: var(--ink);
}

.t-chip--outline {
  background: transparent;
}

/* ── Avatars ── */
.t-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-grid;
  place-items: center;
  background: var(--paper-3);
  color: var(--ink-2);
  font-weight: var(--fw-semibold);
  font-size: var(--fs-sm);
  border: 1px solid var(--line);
  flex-shrink: 0;
  text-transform: uppercase;
}

.t-avatar--xs {
  width: 18px;
  height: 18px;
  font-size: 9px;
}

.t-avatar--sm {
  width: 24px;
  height: 24px;
  font-size: 10px;
}

.t-avatar--lg {
  width: 44px;
  height: 44px;
  font-size: var(--fs-lg);
}

/* ── Tabs ── */
.t-tabs {
  display: flex;
  border-bottom: 1px solid var(--line);
}

.t-tab {
  padding: 9px 14px;
  font-size: var(--fs-md);
  font-weight: var(--fw-medium);
  color: var(--ink-3);
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color var(--t-fast), border-color var(--t-fast);
  cursor: pointer;
  white-space: nowrap;
}

.t-tab:hover {
  color: var(--ink-2);
}

.t-tab.is-active {
  color: var(--ink);
  border-bottom-color: var(--ink);
}

.t-tab-count {
  margin-left: 6px;
  font-family: var(--font-mono);
  font-size: var(--fs-xs);
  color: var(--ink-3);
}

/* ── Tables ── */
.t-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: var(--fs-md);
}

.t-table thead th {
  text-align: left;
  font-weight: var(--fw-medium);
  color: var(--ink-3);
  font-size: var(--fs-xs);
  letter-spacing: .04em;
  text-transform: uppercase;
  padding: 11px 14px;
  border-bottom: 1px solid var(--line);
  background: var(--paper-2);
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}

.t-table tbody td {
  padding: 14px 14px;
  border-bottom: 1px solid var(--line);
  vertical-align: middle;
}

.t-table tbody tr {
  background: var(--card);
  cursor: pointer;
  transition: background 130ms ease, box-shadow 130ms ease;
}

.t-table tbody tr:hover {
  background: var(--paper-2);
  box-shadow: inset 3px 0 0 var(--accent);
}

.t-table tbody tr:last-child td {
  border-bottom: none;
}

.t-table-no-hover tbody tr {
  cursor: default;
}

.t-table-no-hover tbody tr:hover {
  background: var(--card);
}

/* ── Modal ── */
.t-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(16, 24, 40, .42);
  display: grid;
  place-items: center;
  padding: 24px;
  z-index: 1000;
}

.t-modal {
  background: var(--card);
  border-radius: var(--r-4);
  box-shadow: var(--shadow-lg);
  width: 520px;
  max-width: 100%;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.t-modal-head {
  padding: 14px 18px;
  border-bottom: 1px solid var(--line);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.t-modal-head h2 {
  margin: 0;
  font-size: var(--fs-lg);
  font-weight: var(--fw-semibold);
}

.t-modal-body {
  padding: 18px;
  overflow-y: auto;
  flex: 1;
}

.t-modal-foot {
  padding: 12px 18px;
  border-top: 1px solid var(--line);
  background: var(--paper-2);
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* ── Alerts ── */
.t-alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid var(--line);
  background: var(--paper-2);
  border-radius: var(--r-3);
  font-size: var(--fs-md);
  color: var(--ink-2);
}

.t-alert--success {
  border-color: var(--success-line);
  background: var(--success-soft);
  color: var(--success);
}

.t-alert--warn {
  border-color: var(--warn-line);
  background: var(--warn-soft);
  color: var(--warn);
}

.t-alert--danger {
  border-color: var(--danger-line);
  background: var(--danger-soft);
  color: var(--danger);
}

.t-alert--info {
  border-color: var(--info-line);
  background: var(--info-soft);
  color: var(--info);
}

.t-alert strong {
  font-weight: var(--fw-semibold);
}

.t-alert-body {
  flex: 1;
}

.t-alert-title {
  font-weight: var(--fw-semibold);
  margin-bottom: 2px;
}

.t-kbd {
  display: inline-block;
  font-family: var(--font-mono);
  font-size: var(--fs-xs);
  color: var(--ink-3);
  border: 1px solid var(--line);
  border-radius: 3px;
  padding: 1px 5px;
  background: var(--paper);
}

.t-divider {
  height: 1px;
  background: var(--line);
  margin: 12px 0;
}

/* ── Layout helpers ── */
.t-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.t-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.t-stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.t-cluster {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.t-spread {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.t-grow {
  flex: 1;
  min-width: 0;
}

/* ════════════════════════════════════════════
   APP SHELL
   ════════════════════════════════════════════ */
.sk-app {
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: var(--paper);
}

/*
 * SKTICK-DB-001 §2.4 — the assignment-only chrome.
 *
 * A principal with zero space memberships (a franchise outlet manager) gets no
 * sidebar and no top bar, because both carry the space switcher, space names
 * and space-scoped counts. With the sidebar gone the main column simply takes
 * the full width.
 *
 * These users open the console on a phone, so this must be comfortable at
 * mobile width — it is the one surface that may not assume a wide viewport.
 */
.sk-app--bare {
  display: block;
  overflow: auto;
}
.sk-app--bare .sk-main {
  width: 100%;
  max-width: 100%;
}
.sk-app--bare .sk-content {
  padding: 0;
}

.sk-sidebar {
  width: 240px;
  flex-shrink: 0;
  background:
    radial-gradient(130% 32% at 0% 0%, var(--accent-soft), transparent 60%),
    linear-gradient(180deg, var(--card) 0%, var(--paper) 100%);
  border-right: 1px solid var(--line);
  box-shadow: 1px 0 0 rgba(0, 0, 0, 0.01), inset -1px 0 0 rgba(255, 255, 255, 0.4);
  display: flex;
  flex-direction: column;
  padding: 14px 12px 0;
  overflow: hidden;
}

.sk-sidebar-ws-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 8px 12px;
  border-bottom: 1px solid var(--line);
  margin-bottom: 4px;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
}

.sk-sidebar-ws-logo {
  width: 38px;
  height: 38px;
  border-radius: var(--r-3);
  display: grid;
  place-items: center;
  background: linear-gradient(140deg, #2b2b48 0%, #16162a 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.4px;
  flex-shrink: 0;
  box-shadow: 0 4px 12px -4px rgba(18, 18, 38, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
  transition: transform var(--t-base) var(--ease-out),
    box-shadow var(--t-base) var(--ease-out);
}

.sk-sidebar-ws-btn:hover .sk-sidebar-ws-logo {
  transform: translateY(-1px);
  box-shadow: 0 9px 20px -6px rgba(18, 18, 38, 0.55),
    inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

.sk-sidebar-ws-name {
  font-size: var(--fs-lg);
  font-weight: var(--fw-semibold);
  color: var(--ink);
  line-height: 1.3;
}

.sk-sidebar-ws-sub {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: var(--ink);
}

.sk-nav-scroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 8px;
}

.sk-nav-scroll::-webkit-scrollbar {
  width: 0;
}

.sk-nav-group {
  margin-top: 22px;
}

.sk-nav-group:first-child {
  margin-top: 6px;
}

.sk-nav-group-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--ink-4);
  text-transform: uppercase;
  padding: 0 10px 8px;
  display: block;
}

.sk-nav-link {
  position: relative;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 8px 10px;
  border-radius: var(--r-2);
  font-size: var(--fs-md);
  font-weight: var(--fw-medium);
  color: var(--ink-2);
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  transition: background var(--t-fast) var(--ease-out),
    color var(--t-fast) var(--ease-out);
}

/* Active accent rail — slides in from nothing to a tidy pill on the left edge. */
.sk-nav-link::before {
  content: "";
  position: absolute;
  left: 1px;
  top: 50%;
  width: 3px;
  height: 0;
  border-radius: 3px;
  background: var(--accent);
  transform: translateY(-50%);
  transition: height var(--t-base) var(--ease-out);
}

.sk-nav-link:hover {
  background: var(--paper-2);
  color: var(--ink);
}

.sk-nav-link.is-active {
  background: var(--accent-soft);
  color: var(--accent-ink);
  font-weight: var(--fw-semibold);
}

.sk-nav-link.is-active::before {
  height: 18px;
}

.sk-nav-link-icon {
  display: flex;
  align-items: center;
  opacity: 0.55;
  transition: opacity var(--t-fast) var(--ease-out),
    color var(--t-fast) var(--ease-out);
}

.sk-nav-link:hover .sk-nav-link-icon {
  opacity: 0.8;
}

.sk-nav-link.is-active .sk-nav-link-icon {
  opacity: 1;
  color: var(--accent);
}

.sk-nav-link-label {
  flex: 1;
}

.sk-nav-badge {
  font-size: 10.5px;
  font-weight: 700;
  background: var(--paper-3);
  border-radius: 10px;
  padding: 1px 7px;
  min-width: 18px;
  text-align: center;
  color: var(--ink-3);
  font-family: var(--font-mono);
  transition: background var(--t-fast) var(--ease-out),
    color var(--t-fast) var(--ease-out);
}

.sk-nav-link.is-active .sk-nav-badge {
  background: var(--accent);
  color: #fff;
}

.sk-nav-dot {
  width: 9px;
  height: 9px;
  border-radius: 3px;
  flex-shrink: 0;
  display: inline-block;
  box-shadow: 0 1px 3px -1px rgba(0, 0, 0, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.sk-space-trigger:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(18, 18, 38, 0.06),
    0 10px 22px -10px rgba(18, 18, 38, 0.28) !important;
}

/* Dark-mode toggle pill (sits at the right of the "Light/Dark mode" nav row) */
.sk-theme-toggle .sk-theme-switch {
  position: relative;
  width: 34px;
  height: 18px;
  border-radius: 999px;
  background: var(--line-strong);
  flex: none;
  transition: background var(--t-base) var(--ease-out);
}

.sk-theme-toggle .sk-theme-switch.is-on {
  background: var(--accent);
}

.sk-theme-knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  transition: transform var(--t-base) var(--ease-out);
}

.sk-theme-switch.is-on .sk-theme-knob {
  transform: translateX(16px);
}

.sk-user-footer {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  /* Negative side margins cancel the sidebar's 10px padding so the bar
     spans the full width, edge to edge. Bottom margin lifts it slightly
     up off the bottom edge. */
  margin: 10px -12px 0;
  padding: 13px 16px calc(13px + env(safe-area-inset-bottom, 0px));
  background: linear-gradient(180deg, var(--paper-2), var(--paper-3));
  border: none;
  border-top: 1px solid var(--line);
  border-radius: 0;
  flex-shrink: 0;
  cursor: default;
  transition: background var(--t-fast) var(--ease-out);
}

.sk-user-footer:hover {
  background: var(--paper-3);
}

/* Premium hover card floating above the footer. Fixed positioning lets it
   escape the sidebar's overflow clip so it can be wide enough to show the
   full email on a single line. */
.sk-user-tip {
  position: fixed;
  left: 14px;
  bottom: 66px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 6px;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--r-4);
  box-shadow: var(--shadow-lg);
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transform: translateY(6px) scale(0.98);
  transform-origin: bottom left;
  transition: opacity var(--t-base) var(--ease-out),
    transform var(--t-base) var(--ease-out),
    visibility var(--t-base);
  z-index: 1200;
  pointer-events: none;
}

.sk-user-footer:hover .sk-user-tip {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
  pointer-events: auto;
}

/* Little caret pointing down at the footer */
.sk-user-tip::after {
  content: "";
  position: absolute;
  left: 30px;
  top: 100%;
  width: 10px;
  height: 10px;
  background: var(--card);
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  transform: translateY(-5px) rotate(45deg);
}

/* Invisible bridge across the gap so moving the cursor into the card
   keeps it open (and the Log out button clickable). */
.sk-user-tip::before {
  content: "";
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  height: 14px;
}

.sk-user-tip-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #f97316, #db2777);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}

.sk-user-tip-body {
  min-width: 0;
}

.sk-user-tip-name {
  font-size: var(--fs-md);
  font-weight: var(--fw-semibold);
  color: var(--ink);
  letter-spacing: 0.1px;
}

.sk-user-tip-email {
  font-size: var(--fs-sm);
  font-weight: var(--fw-medium);
  color: var(--ink-3);
  margin-top: 2px;
  white-space: nowrap;
}

/* Shared hover-card internals (used by footer + top-bar tips) */
.sk-tip-head {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 8px 8px 9px;
}

.sk-tip-logout {
  position: relative;
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  padding: 9px 10px;
  border: none;
  background: none;
  border-radius: var(--r-2);
  font-size: var(--fs-md);
  font-weight: var(--fw-medium);
  color: var(--danger);
  text-align: left;
  cursor: pointer;
  transition: background var(--t-fast) var(--ease-out);
}

/* Inset divider above the Log out row */
.sk-tip-logout::before {
  content: "";
  position: absolute;
  top: -2px;
  left: 8px;
  right: 8px;
  height: 1px;
  background: var(--line);
}

.sk-tip-logout:hover {
  background: var(--danger-soft);
}

.sk-user-avatar {
  position: relative;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #f97316, #db2777);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px var(--card), 0 3px 8px -2px rgba(219, 39, 119, 0.45);
  transition: transform var(--t-base) var(--ease-out),
    box-shadow var(--t-base) var(--ease-out);
}

/* Online status dot */
.sk-user-avatar::after {
  content: "";
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--success);
  border: 2px solid var(--card);
}

.sk-user-footer:hover .sk-user-avatar {
  transform: translateY(-1px);
  box-shadow: 0 0 0 2px var(--card), 0 6px 14px -3px rgba(219, 39, 119, 0.5);
}

/* Let the text column shrink so long emails truncate instead of
   spilling past the card edge. */
.sk-user-footer .t-grow {
  min-width: 0;
}

.sk-user-name {
  font-size: var(--fs-sm);
  font-weight: var(--fw-semibold);
  color: var(--ink);
  letter-spacing: 0.1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sk-user-role {
  font-size: 11px;
  font-weight: var(--fw-medium);
  color: var(--ink-3);
  letter-spacing: 0.1px;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sk-settings-btn {
  width: 22px;
  height: 22px;
  border-radius: var(--r-1);
  display: grid;
  place-items: center;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--ink-3);
  flex-shrink: 0;
}

.sk-settings-btn:hover {
  background: var(--paper-2);
  color: var(--ink);
}

.sk-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

.sk-topbar {
  height: 62px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 18px;
  background: var(--card);
  border-bottom: 1px solid var(--line);
}

.sk-topbar-crumbs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.sk-topbar-crumb {
  font-size: var(--fs-xl);
  font-weight: var(--fw-medium);
  color: var(--ink-3);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.sk-topbar-crumb.is-active {
  font-weight: var(--fw-semibold);
  color: var(--ink);
  cursor: default;
}

.sk-topbar-crumb-sep {
  color: var(--ink-4);
  font-size: var(--fs-md);
}

.sk-search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--paper-2);
  border: 1px solid var(--line);
  border-radius: var(--r-2);
  padding: 5px 10px;
  width: 280px;
  cursor: text;
  color: var(--ink-3);
  font-size: 12.5px;
}

.sk-search-bar:hover {
  border-color: var(--line-strong);
}

.sk-bell-btn {
  position: relative;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--ink-3);
  flex-shrink: 0;
}

.sk-bell-btn:hover {
  color: var(--ink);
}

.sk-bell-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  background: var(--danger);
  border-radius: 99px;
  display: grid;
  place-items: center;
  font-size: 9px;
  font-weight: 700;
  color: #fff;
  border: 2px solid var(--card);
}

/* ── Top-bar user avatar + premium hover card ── */
.sk-topbar-user {
  position: relative;
  display: flex;
  align-items: center;
  gap: 9px;
  flex-shrink: 0;
  padding: 4px 5px 4px 13px;
  border: 1px solid var(--line);
  border-radius: var(--r-full);
  background: var(--card);
  cursor: pointer;
  transition: background var(--t-fast) var(--ease-out),
    border-color var(--t-fast) var(--ease-out),
    box-shadow var(--t-fast) var(--ease-out);
}

.sk-topbar-user:hover {
  background: var(--paper-2);
  border-color: var(--line-strong);
  box-shadow: var(--shadow-sm);
}

.sk-topbar-user-name {
  font-size: var(--fs-md);
  font-weight: var(--fw-semibold);
  color: var(--ink);
  letter-spacing: 0.1px;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* On narrow screens, drop the text label and keep just the avatar. */
@media (max-width: 720px) {
  .sk-topbar-user-name {
    display: none;
  }
}

.sk-topbar-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, #f97316, #db2777);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.3px;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 0 0 0 var(--accent-soft);
  transition: box-shadow var(--t-fast) var(--ease-out);
}

.sk-topbar-user:hover .sk-topbar-avatar {
  box-shadow: 0 0 0 3px var(--paper-3);
}

.sk-topbar-user-tip {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 6px;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--r-4);
  box-shadow: var(--shadow-lg);
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-6px) scale(0.98);
  transform-origin: top right;
  transition: opacity var(--t-base) var(--ease-out),
    transform var(--t-base) var(--ease-out),
    visibility var(--t-base);
  z-index: 1200;
  pointer-events: none;
}

.sk-topbar-user:hover .sk-topbar-user-tip {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
  pointer-events: auto;
}

/* Caret pointing up at the avatar (right side) */
.sk-topbar-user-tip::before {
  content: "";
  position: absolute;
  right: 13px;
  bottom: 100%;
  width: 10px;
  height: 10px;
  background: var(--card);
  border-left: 1px solid var(--line);
  border-top: 1px solid var(--line);
  transform: translateY(5px) rotate(45deg);
}

/* Invisible bridge across the gap above the card so the cursor can reach
   it to click Log out without the card closing. */
.sk-topbar-user-tip::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  height: 14px;
}

.sk-content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ── Page header ── */
.sk-page-head {
  padding: 24px 40px 14px;
  background: var(--card);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px 16px;
  flex-shrink: 0;
  flex-wrap: wrap;
}
/* Action cluster in the header wraps neatly under the title on small screens. */
.sk-page-head-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.sk-page-head-title {
  font-size: 23px;
  font-weight: var(--fw-bold);
  color: var(--ink);
  letter-spacing: -0.4px;
}

.sk-page-head-sub {
  font-size: 12.5px;
  color: var(--ink-3);
  margin-top: 3px;
}

/* ── Filter bar ── */
.sk-filter-bar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 40px 8px;
  height: 44px;
  background: var(--card);
  flex-shrink: 0;
  overflow-x: auto;
}

.sk-filter-bar::-webkit-scrollbar {
  height: 0;
}

.sk-filter-divider {
  width: 1px;
  height: 18px;
  background: var(--line);
  margin: 0 8px;
  flex-shrink: 0;
}

.sk-filter-label {
  font-size: 12px;
  color: var(--ink-3);
  white-space: nowrap;
  flex-shrink: 0;
}

.sk-filter-chip {
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 11px;
  border-radius: var(--r-full);
  border: 1px solid transparent;
  background: transparent;
  font-size: var(--fs-sm);
  font-weight: var(--fw-medium);
  color: var(--ink-2);
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background var(--t-fast), color var(--t-fast);
}

.sk-filter-chip:hover {
  background: var(--paper-2);
  color: var(--ink);
}

.sk-filter-chip.is-active {
  background: var(--ink);
  color: var(--paper);
  border-color: var(--ink);
}

.sk-ch-chip {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 8px;
  border-radius: var(--r-2);
  border: 1px solid transparent;
  background: transparent;
  font-size: var(--fs-xs);
  font-weight: var(--fw-medium);
  color: var(--ink-3);
  cursor: pointer;
  flex-shrink: 0;
}

.sk-ch-chip:hover {
  background: var(--paper-2);
  color: var(--ink-2);
}

.sk-ch-chip.is-active {
  background: var(--card);
  border-color: var(--line);
  color: var(--ink);
}

/* ── Search input (inline filter bar) ── */
.sk-inline-search {
  position: relative;
  flex: 1;
  max-width: 280px;
}

.sk-inline-search svg {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--ink-4);
}

.sk-inline-search input {
  width: 100%;
  height: 28px;
  padding: 0 10px 0 28px;
  border: 1px solid var(--line);
  background: var(--paper);
  border-radius: var(--r-2);
  font-size: var(--fs-sm);
  color: var(--ink);
  outline: none;
}

.sk-inline-search input:focus {
  border-color: var(--accent);
  box-shadow: var(--shadow-focus);
}

.sk-inline-search input::placeholder {
  color: var(--ink-4);
}

/* ── Table wrap ── */
.sk-table-wrap {
  flex: 1;
  overflow: auto;
  background: var(--paper-2);
  padding: 16px 40px 32px;
}

.sk-table-card {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--r-4);
  width: 100%;
  box-shadow: var(--shadow);
  /* Horizontal scroll lives on the card so the scrollbar sits directly under
     the rows — visible and obvious that more columns are reachable. */
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  scrollbar-color: var(--line-strong) var(--paper-2);
}
/* Always-visible, styled horizontal scrollbar (WebKit). */
.sk-table-card::-webkit-scrollbar {
  height: 11px;
}
.sk-table-card::-webkit-scrollbar-track {
  background: var(--paper-2);
  border-bottom-left-radius: var(--r-4);
  border-bottom-right-radius: var(--r-4);
}
.sk-table-card::-webkit-scrollbar-thumb {
  background: var(--line-strong);
  border-radius: 999px;
  border: 3px solid var(--paper-2);
}
.sk-table-card::-webkit-scrollbar-thumb:hover {
  background: var(--ink-4);
}
/* Force the table to its natural (content) width so the card actually scrolls. */
.sk-table-card .t-table {
  min-width: max-content;
}

/* ── Search row above a list/table (mirrors the Inbox layout) ── */
.sk-search-row {
  display: flex;
  padding: 8px 40px 12px;
  background: var(--card);
  flex-shrink: 0;
}
.sk-search-row-inner {
  width: 100%;
  max-width: 420px;
}

/* ── Responsive "table → cards" list (mobile + tablet) ── */
.sk-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 0 4px;
}
.sk-data-card {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--r-3);
  box-shadow: var(--shadow-sm);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
  transition: border-color var(--t-fast), background var(--t-fast);
}
.sk-data-card:hover {
  border-color: var(--line-strong);
  background: var(--paper-2);
}
.sk-data-card-head {
  display: flex;
  align-items: center;
  gap: 10px;
}
.sk-data-card-title {
  font-size: var(--fs-md);
  font-weight: var(--fw-semibold);
  color: var(--ink);
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sk-data-card-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: var(--fs-sm);
}
.sk-data-card-label {
  color: var(--ink-3);
  flex-shrink: 0;
}
.sk-data-card-value {
  color: var(--ink);
  min-width: 0;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ════════════════════════════════════════════
   REPORTS PAGE
   ════════════════════════════════════════════ */
.sk-reports-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px 40px 28px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: var(--paper-2);
}

.sk-range-bar {
  display: flex;
  gap: 4px;
  align-items: center;
}

.sk-range-btn {
  height: 26px;
  padding: 0 12px;
  border-radius: var(--r-2);
  border: 1px solid transparent;
  background: transparent;
  font-size: var(--fs-sm);
  font-weight: var(--fw-medium);
  color: var(--ink-3);
  cursor: pointer;
}

.sk-range-btn:hover {
  background: var(--paper-3);
  color: var(--ink-2);
}

.sk-range-btn.is-active {
  background: var(--card);
  border-color: var(--line);
  color: var(--ink);
  box-shadow: var(--shadow-sm);
}

.sk-kpi-strip {
  display: flex;
  gap: 12px;
}

.sk-kpi-card {
  flex: 1;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--r-3);
  padding: 16px 18px;
  box-shadow: var(--shadow-sm);
}

.sk-kpi-label {
  font-size: var(--fs-xs);
  color: var(--ink-3);
  text-transform: uppercase;
  letter-spacing: .05em;
  font-weight: var(--fw-medium);
  margin-bottom: 6px;
}

.sk-kpi-value {
  font-size: var(--fs-2xl);
  font-weight: var(--fw-bold);
  color: var(--ink);
  letter-spacing: -0.5px;
}

.sk-kpi-delta {
  font-size: var(--fs-sm);
  color: var(--ink-3);
  margin-top: 4px;
}

.sk-charts-row {
  display: flex;
  gap: 12px;
}

.sk-charts-row>.t-card {
  flex: 1;
}

.sk-stacked-bar {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sk-sb-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sk-sb-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: var(--fs-xs);
  color: var(--ink-2);
}

.sk-sb-track {
  height: 8px;
  border-radius: 4px;
  background: var(--paper-3);
  overflow: hidden;
}

.sk-sb-fill {
  height: 100%;
  border-radius: 4px;
}

/* ════════════════════════════════════════════
   REPORTS — premium entrance + chart animations
   ════════════════════════════════════════════ */
@keyframes skFadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: none; } }
@keyframes skBarGrow { from { transform: scaleY(0); } to { transform: scaleY(1); } }
@keyframes skGrowX { from { transform: scaleX(0); } to { transform: scaleX(1); } }
@keyframes skDonutIn { from { opacity: 0; transform: rotate(-90deg) scale(0.82); } to { opacity: 1; transform: rotate(-90deg) scale(1); } }
@keyframes skPopIn { 0% { opacity: 0; transform: scale(0.9); } 60% { transform: scale(1.03); } 100% { opacity: 1; transform: scale(1); } }

/* KPI cards — fade up, staggered, with a hover lift + gradient top edge */
.sk-kpi-card {
  position: relative;
  overflow: hidden;
  border-radius: var(--r-4);
  box-shadow: var(--shadow);
  animation: skFadeUp .5s cubic-bezier(.2,.7,.3,1) both;
  transition: transform .18s ease, box-shadow .18s ease;
}
.sk-kpi-card::before {
  content: '';
  position: absolute; top: 0; left: 0; right: 0; height: 3px;
  background: linear-gradient(90deg, var(--accent), #6366f1);
  opacity: 0; transition: opacity .18s ease;
}
.sk-kpi-card:hover { transform: translateY(-3px); box-shadow: var(--shadow-md); }
.sk-kpi-card:hover::before { opacity: 1; }
.sk-kpi-strip .sk-kpi-card:nth-child(1) { animation-delay: .03s; }
.sk-kpi-strip .sk-kpi-card:nth-child(2) { animation-delay: .09s; }
.sk-kpi-strip .sk-kpi-card:nth-child(3) { animation-delay: .15s; }
.sk-kpi-strip .sk-kpi-card:nth-child(4) { animation-delay: .21s; }
.sk-kpi-value { font-variant-numeric: tabular-nums; }

/* Chart cards — fade up, staggered, hover lift */
.sk-reports-body .t-card {
  border-radius: var(--r-4);
  box-shadow: var(--shadow);
  animation: skFadeUp .55s cubic-bezier(.2,.7,.3,1) both;
  transition: transform .18s ease, box-shadow .18s ease;
}
.sk-reports-body .t-card:hover { transform: translateY(-2px); box-shadow: var(--shadow-md); }
.sk-charts-row:nth-of-type(1) > .t-card:nth-child(1) { animation-delay: .26s; }
.sk-charts-row:nth-of-type(1) > .t-card:nth-child(2) { animation-delay: .32s; }
.sk-charts-row:nth-of-type(2) > .t-card:nth-child(1) { animation-delay: .30s; }
.sk-charts-row:nth-of-type(2) > .t-card:nth-child(2) { animation-delay: .36s; }
.sk-charts-row:nth-of-type(2) > .t-card:nth-child(3) { animation-delay: .42s; }

/* Stacked bars grow from the left */
.sk-sb-fill {
  transform-origin: left center;
  animation: skGrowX .85s cubic-bezier(.2,.7,.3,1) both;
}

/* Bar-chart bars grow up from the baseline */
.sk-bar-rect {
  transform-box: fill-box;
  transform-origin: center bottom;
  animation: skBarGrow .7s cubic-bezier(.2,.7,.3,1) both;
}

/* Donut scales + fades in (keeps its -90° orientation) */
.sk-donut { animation: skDonutIn .7s cubic-bezier(.2,.7,.3,1) both; transform-origin: center; }

/* Donut segments DRAW in one-by-one — the headline wow moment */
@keyframes skSegDraw { from { stroke-dasharray: 0 1200; } to { stroke-dasharray: var(--d) var(--g); } }
.sk-seg {
  animation: skSegDraw .95s cubic-bezier(.2,.7,.3,1) both;
  transition: stroke-width .18s ease, opacity .18s ease;
  cursor: pointer;
}
.sk-donut:hover .sk-seg { opacity: 0.45; }
.sk-donut .sk-seg:hover { opacity: 1; stroke-width: 28; }

/* Bar-chart bars react on hover */
.sk-bar-rect { transition: opacity .15s ease, filter .15s ease; cursor: pointer; }
.sk-bar-rect:hover { opacity: 1 !important; filter: brightness(1.1) saturate(1.1); }

/* KPI value gives a tiny pop as it counts up */
.sk-kpi-value { animation: skPopIn .6s cubic-bezier(.2,.7,.3,1) both; animation-delay: inherit; }

/* Light SHEEN sweeps across each card once on entrance */
@keyframes skSweep { 0% { left: -60%; } 70%, 100% { left: 150%; } }
.sk-reports-body .t-card { position: relative; overflow: hidden; }
.sk-kpi-card::after,
.sk-reports-body .t-card::after {
  content: '';
  position: absolute; top: 0; bottom: 0; left: -60%; width: 38%;
  background: linear-gradient(105deg, transparent, rgba(99,102,241,0.10), transparent);
  transform: skewX(-16deg);
  pointer-events: none;
  animation: skSweep 1.5s ease both;
  animation-delay: inherit;
}
.sk-kpi-card:hover { box-shadow: var(--shadow-md), 0 0 0 1px var(--accent-line); }

/* Donut gets soft depth */
.sk-donut { filter: drop-shadow(0 6px 14px rgba(16,24,40,0.10)); }

/* Legend dots gently pulse-pop in */
.sk-donut + div > div { animation: skFadeUp .5s ease both; }

/* ════════════════════════════════════════════
   RESPONSIVE
   Breakpoints are kept identical to src/theme/responsive.ts so the CSS web UI
   and the React-Native screens switch layouts at exactly the same widths:
     desktop ≥ 1200px · tablet 768–1199px · mobile < 768px
   ════════════════════════════════════════════ */

/* Mobile-only menu trigger + drawer backdrop (hidden until the mobile query) */
.sk-hamburger {
  display: none;
  width: 32px;
  height: 32px;
  border-radius: var(--r-2);
  border: 1px solid var(--line);
  background: var(--card);
  place-items: center;
  color: var(--ink-2);
  flex-shrink: 0;
  margin-right: 2px;
}

.sk-hamburger:hover {
  background: var(--paper-2);
  color: var(--ink);
}

.sk-nav-backdrop {
  display: none;
}

/* Tablet + mobile: a compact search pill, KPI cards wrap */
@media (max-width: 1199px) {
  .sk-search-bar {
    width: 44px;
  }

  .sk-search-bar span {
    display: none;
  }

  .sk-kpi-strip {
    flex-wrap: wrap;
  }
}

/* Tablet (768–1199): collapse the sidebar to an icon rail */
@media (min-width: 768px) and (max-width: 1199px) {
  .sk-sidebar {
    width: 56px;
  }

  .sk-sidebar-ws-name,
  .sk-sidebar-ws-sub,
  .sk-nav-link-label,
  .sk-nav-badge,
  .sk-nav-group-label,
  .sk-user-name,
  .sk-user-role {
    display: none;
  }

  .sk-nav-link {
    justify-content: center;
    gap: 0;
    padding: 8px;
  }

  .sk-nav-link-icon {
    opacity: 1;
  }

  .sk-sidebar-ws-btn {
    justify-content: center;
    padding: 0 0 12px;
  }

  .sk-user-footer {
    justify-content: center;
  }
}

/* Mobile (<768): sidebar becomes an off-canvas drawer opened by the hamburger */
@media (max-width: 767px) {
  .sk-hamburger {
    display: grid;
  }

  .sk-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 1100;
    width: 256px;
    transform: translateX(-100%);
    transition: transform var(--t-base) var(--ease-out);
    box-shadow: var(--shadow-lg);
  }

  .sk-app.sk-nav-open .sk-sidebar {
    transform: translateX(0);
  }

  .sk-nav-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(16, 24, 40, .42);
    z-index: 1050;
  }

  .sk-app.sk-nav-open .sk-nav-backdrop {
    display: block;
  }

  .sk-topbar {
    padding: 0 14px;
    gap: 8px;
  }

  .sk-page-head {
    padding: 18px 20px 14px;
  }

  .sk-filter-bar {
    padding-inline: 20px;
  }

  .sk-search-row {
    padding-inline: 20px;
  }

  .sk-table-wrap {
    padding: 10px 20px 24px;
  }

  .sk-reports-body {
    padding: 20px;
  }

  .sk-kpi-card {
    min-width: calc(50% - 8px);
  }

  .sk-charts-row {
    flex-direction: column;
  }
}

/* Toast entrance — slides down from the top-center stack. */
@keyframes t-slidedown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ════════════════════════════════════════════
   INTERNAL SPACE PARTITION (SKTICK-INTSPACE-001)
   The PUBLIC/INTERNAL boundary must be VISIBLE everywhere an internal ticket
   can appear. The \`--internal\` accent (default Teal) is deliberately NEVER the
   customer \`--accent\` (indigo) so the two are never confused.
   ════════════════════════════════════════════ */
:root {
  --internal: oklch(0.52 0.12 215);
  --internal-ink: oklch(0.40 0.11 215);
  --internal-soft: oklch(0.965 0.03 215);
  --internal-mute: oklch(0.93 0.045 215);
  --internal-line: oklch(0.84 0.07 215);
}

/* ── The lockup — persistent "this is INTERNAL" marker (pill variant) ── */
.ilock {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 22px;
  padding: 0 9px;
  border-radius: var(--r-full);
  background: var(--internal);
  color: #fff;
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  letter-spacing: 0.02em;
  white-space: nowrap;
  line-height: 1;
}

.ilock--lg {
  height: 28px;
  padding: 0 12px;
  font-size: var(--fs-sm);
}

.ilock-key {
  font-family: var(--font-mono);
  font-weight: var(--fw-bold);
  opacity: 0.85;
}

/* ── Internal-tinted chip (roles, type tag) ── */
.t-chip--internal {
  color: var(--internal-ink);
  background: var(--internal-soft);
  border-color: var(--internal-line);
}

.t-chip--internal .t-chip-dot {
  background: var(--internal);
}

/* ── Employee requester chip (SK People) — distinct from a CRM contact ── */
.t-emp {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 22px;
  padding: 0 9px;
  border-radius: var(--r-full);
  background: var(--internal-soft);
  border: 1px solid var(--internal-line);
  color: var(--internal-ink);
  font-size: 12.5px;
  font-weight: var(--fw-medium);
  white-space: nowrap;
}

/* ── List-row internal rail — 3px inset rule on internal ticket rows ── */
.irow-rail {
  box-shadow: inset 3px 0 0 0 var(--internal);
}

/* ── Top-bar focus-strip inbox-zero celebration ── */
@keyframes t-spark {
  0%, 100% { transform: scale(1) rotate(0deg); opacity: 1; }
  50% { transform: scale(1.18) rotate(8deg); opacity: 0.85; }
}

.t-spark {
  animation: t-spark 1800ms var(--ease-out) infinite;
}

@media (prefers-reduced-motion: reduce) {
  .t-spark { animation: none; }
}

/* ── Popover entrance (space switcher dropdown) ── */
@keyframes t-slideup {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}`, "",{"version":3,"sources":["webpack://./src/theme/theme.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;AACA;EACE,KAAK,sBAAsB,EAAE,YAAY,EAAE;EAC3C,MAAM,qBAAqB,EAAE,UAAU,EAAE;EACzC,OAAO,qBAAqB,EAAE,UAAU,EAAE;AAC5C;AACA;EACE,WAAW,UAAU,EAAE,qBAAqB,EAAE;EAC9C,MAAM,UAAU,EAAE,mBAAmB,EAAE;AACzC;AACA;EACE,WAAW,YAAY,EAAE,oCAAoC,EAAE;EAC/D,MAAM,YAAY,EAAE,uCAAuC,EAAE;AAC/D;AACA;EACE,OAAO,0CAA0C,EAAE;EACnD,YAAY,yCAAyC,EAAE;AACzD;AACA;EACE,kBAAkB;EAClB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,uBAAuB;EACnF,kBAAkB;EAClB,WAAW,EAAE,gBAAgB;EAC7B,iBAAiB;EACjB,uBAAuB,EAAE,QAAQ;EACjC,mBAAmB;EACnB;;wDAEsD;EACtD,oCAAoC;EACpC,iEAAiE;EACjE,gBAAgB;EAChB,sDAAsD;AACxD;AACA,kEAAkE;AAClE;EACE,WAAW;EACX,kBAAkB,EAAE,MAAM,EAAE,OAAO,EAAE,UAAU,EAAE,YAAY;EAC7D,oFAAoF;EACpF,0CAA0C;EAC1C,oDAAoD;EACpD,oBAAoB;AACtB;AACA,2CAA2C;AAC3C;EACE,WAAW;EACX,kBAAkB,EAAE,SAAS,EAAE,SAAS,EAAE,YAAY,EAAE,aAAa;EACrE,2BAA2B;EAC3B,kFAAkF;EAClF,oBAAoB;EACpB,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,aAAa,EAAE,mBAAmB;EAClC,sFAAsF;EACtF,oCAAoC;EACpC,6HAA6H;EAC7H,mBAAmB;EACnB,iDAAiD;AACnD;AACA,wCAAwC;AACxC;;EAEE,WAAW;EACX,kBAAkB,EAAE,WAAW,EAAE,kBAAkB;EACnD,iCAAiC;EACjC,6CAA6C;AAC/C;AACA,wBAAwB,qBAAqB,EAAE;AAC/C,uCAAuC;AACvC,uBAAuB,kBAAkB,EAAE,UAAU,EAAE;AACvD;EACE,kBAAkB;EAClB,eAAe,EAAE,2BAA2B,EAAE,sBAAsB;EACpE,eAAe;EACf,kEAAkE;EAClE,6BAA6B,EAAE,qBAAqB;EACpD,oCAAoC,EAAE,wBAAwB;AAChE;AACA;EACE,kBAAkB;EAClB,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB;EACxD,kBAAkB,EAAE,iBAAiB,EAAE,eAAe;AACxD;AACA,wBAAwB;AACxB;;EAEE,YAAY;EACZ,kBAAkB,EAAE,UAAU;EAC9B,oBAAoB,EAAE,UAAU;EAChC,eAAe;EACf,8CAA8C;EAC9C,sCAAsC;AACxC;AACA,0BAA0B,SAAS,EAAE,qBAAqB,EAAE,eAAe,EAAE;AAC7E,yBAAyB,UAAU,EAAE,UAAU,EAAE,qBAAqB,EAAE;;AAExE;;iDAEiD;AACjD,wBAAwB,KAAK,UAAU,EAAE,uCAAuC,EAAE,EAAE,OAAO,UAAU,EAAE,eAAe,EAAE,EAAE;AAC1H,2BAA2B,WAAW,sCAAsC,EAAE,EAAE,MAAM,yCAAyC,EAAE,EAAE;AACnI,0BAA0B,KAAK,qBAAqB,EAAE,aAAa,EAAE,EAAE,MAAM,qBAAqB,EAAE,UAAU,EAAE,EAAE,OAAO,UAAU,EAAE,EAAE;AACvI,0BAA0B,WAAW,aAAa,EAAE,oCAAoC,EAAE,EAAE,MAAM,aAAa,EAAE,uCAAuC,EAAE,EAAE;AAC5J,6BAA6B,WAAW,UAAU,EAAE,qBAAqB,EAAE,EAAE,MAAM,UAAU,EAAE,mBAAmB,EAAE,EAAE;;AAEtH;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB;;kBAEgB;EAChB,gBAAgB;AAClB;AACA,0CAA0C;AAC1C,sBAAsB,WAAW,0BAA0B,EAAE,EAAE,MAAM,iCAAiC,EAAE,EAAE;AAC1G,sBAAsB,WAAW,0BAA0B,EAAE,EAAE,MAAM,iCAAiC,EAAE,EAAE;AAC1G;EACE,WAAW,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,oBAAoB;EACzE,kBAAkB;AACpB;AACA;EACE,YAAY,EAAE,aAAa,EAAE,UAAU,EAAE,QAAQ;EACjD,2EAA2E;EAC3E,2CAA2C;AAC7C;AACA;EACE,YAAY,EAAE,aAAa,EAAE,aAAa,EAAE,SAAS;EACrD,2EAA2E;EAC3E,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,uBAAuB;EACvB,iFAAiF;EACjF,uDAAuD;EACvD,gBAAgB;AAClB;AACA,6CAA6C;AAC7C;EACE,WAAW,EAAE,kBAAkB,EAAE,QAAQ,EAAE,sBAAsB,EAAE,cAAc;EACjF,8GAA8G;EAC9G,8EAA8E;EAC9E,2BAA2B,EAAE,uBAAuB;EACpD,aAAa,EAAE,oBAAoB;EACnC,0CAA0C;AAC5C;AACA;EACE,kBAAkB,EAAE,SAAS,EAAE,SAAS,EAAE,YAAY,EAAE,aAAa;EACrE,2BAA2B;EAC3B,kFAAkF;EAClF,oBAAoB;EACpB,iDAAiD;AACnD;AACA;EACE,kBAAkB;EAClB,WAAW,EAAE,YAAY,EAAE,mBAAmB;EAC9C,mBAAmB;EACnB,aAAa,EAAE,mBAAmB;EAClC,gEAAgE;EAChE,oCAAoC;EACpC,sFAAsF;EACtF,kDAAkD;AACpD;AACA;;EAEE,WAAW,EAAE,kBAAkB,EAAE,WAAW,EAAE,mBAAmB;EACjE,iCAAiC;EACjC,8CAA8C;AAChD;AACA,yBAAyB,qBAAqB,EAAE;AAChD;EACE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB;EACpF,oBAAoB,EAAE,kBAAkB;AAC1C;AACA;EACE,kBAAkB;EAClB,eAAe,EAAE,gBAAgB,EAAE,sBAAsB;EACzD,8DAA8D;EAC9D,6BAA6B,EAAE,qBAAqB;EACpD,oCAAoC,EAAE,wBAAwB;AAChE;AACA;EACE,YAAY,EAAE,kBAAkB,EAAE,oBAAoB;EACtD,sCAAsC,EAAE,UAAU,EAAE,eAAe;EACnE,oDAAoD;AACtD;AACA,2BAA2B,UAAU,EAAE,SAAS,EAAE,oBAAoB,EAAE;AACxE,0BAA0B,UAAU,EAAE,UAAU,EAAE,eAAe,EAAE,qBAAqB,EAAE;AAC1F;EACE,eAAe,EAAE,mBAAmB,EAAE,iBAAiB;EACvD,gBAAgB,EAAE,mBAAmB;AACvC;AACA;EACE,qBAAqB,EAAE,eAAe;EACtC,iBAAiB,EAAE,gBAAgB,EAAE,wBAAwB;EAC7D,8BAA8B,EAAE,oCAAoC;EACpE,oBAAoB,EAAE,iBAAiB;AACzC;;AAEA,qDAAqD;AACrD,2BAA2B,KAAK,UAAU,EAAE,EAAE,YAAY,UAAU,EAAE,EAAE;AACxE;EACE,WAAW,EAAE,kBAAkB,EAAE,MAAM,EAAE,SAAS,EAAE,UAAU,EAAE,UAAU;EAC1E,oFAAoF;EACpF,wBAAwB,EAAE,oBAAoB;EAC9C,2CAA2C;AAC7C;;AAEA,kDAAkD;AAClD,0BAA0B,KAAK,yBAAyB,EAAE,EAAE;AAC5D;EACE,kBAAkB,EAAE,WAAW,EAAE,mBAAmB;EACpD,8HAA8H;EAC9H,aAAa;EACb,0CAA0C;EAC1C,iGAAiG;EACjG,yFAAyF;AAC3F;;AAEA,oCAAoC;AACpC,6BAA6B,KAAK,4BAA4B,EAAE,EAAE,OAAO,2BAA2B,EAAE,EAAE;AACxG;EACE,kBAAkB,EAAE,YAAY,EAAE,WAAW,EAAE,mBAAmB;EAClE,oBAAoB,EAAE,0BAA0B,EAAE,gBAAgB;AACpE;AACA;EACE,kBAAkB,EAAE,MAAM,EAAE,SAAS,EAAE,OAAO,EAAE,UAAU;EAC1D,oBAAoB;EACpB,oFAAoF;EACpF,oDAAoD;AACtD;;AAEA,iEAAiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,yHAAyH;AAC3H;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;AACA,kCAAkC;AAClC;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;AACtB;AACA,iCAAiC;AACjC;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;AACtB;AACA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;AACA,0CAA0C;AAC1C;EACE,WAAW;EACX,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,+CAA+C;AACjD;;AAEA;+EAC+E;AAC/E;;EAEE,sCAAsC;AACxC;;AAEA,sEAAsE;AACtE;EACE,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uCAAuC;EACvC,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,qFAAqF;EACrF,8EAA8E;EAC9E,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,aAAa;EACb,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;;EAEd,8BAA8B;EAC9B,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;;EAEf,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,oCAAoC;;EAEpC,8BAA8B;EAC9B,kCAAkC;EAClC,mCAAmC;EACnC,mCAAmC;;EAEnC,4BAA4B;EAC5B,iCAAiC;EACjC,8DAA8D;;EAE9D,+BAA+B;EAC/B,oCAAoC;EACpC,oEAAoE;;EAEpE,2BAA2B;EAC3B,gCAAgC;EAChC,8DAA8D;;EAE9D,6BAA6B;EAC7B,kCAAkC;EAClC,kEAAkE;;EAElE,+BAA+B;EAC/B,oCAAoC;EACpC,oEAAoE;;EAEpE,UAAU;EACV,UAAU;EACV,UAAU;EACV,WAAW;EACX,WAAW;EACX,eAAe;;EAEf,0CAA0C;EAC1C,gFAAgF;EAChF,mFAAmF;EACnF,sFAAsF;EACtF,4CAA4C;;EAE5C,eAAe;EACf,eAAe;EACf,uCAAuC;AACzC;;AAEA;;;yEAGyE;AACzE;EACE,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;;EAEjC,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,oCAAoC;EACpC,oCAAoC;;EAEpC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;;EAEnC,iCAAiC;EACjC,iCAAiC;;EAEjC,oCAAoC;EACpC,oCAAoC;;EAEpC,gCAAgC;EAChC,gCAAgC;;EAEhC,kCAAkC;EAClC,kCAAkC;;EAElC,oCAAoC;EACpC,oCAAoC;;EAEpC,4EAA4E;EAC5E,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;;EAErC,gEAAgE;EAChE,uCAAuC;EACvC,6EAA6E;EAC7E,6EAA6E;EAC7E,gFAAgF;EAChF,4CAA4C;;EAE5C,kBAAkB;AACpB;;AAEA,oEAAoE;AACpE;EACE,gFAAgF;AAClF;;AAEA,sCAAsC;AACtC;;;;EAIE;;uCAEqC;AACvC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,qIAAqI;EACrI,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;EAC3D,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,gEAAgE;AAClE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,gEAAgE;EAChE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,mDAAmD;AACrD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,0BAA0B;EAC1B,wCAAwC;EACxC,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,6BAA6B;EAC7B,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,2DAA2D;EAC3D,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;;;;;;;;;EAUE;AACF;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,cAAc;EACd;;8DAE4D;EAC5D,mCAAmC;EACnC,gFAAgF;EAChF,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd;2CACyC;EACzC;4CAC0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B;2CACyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf;uCACqC;AACvC;;AAEA,iFAAiF;AACjF;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb;uCACqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B;uCACqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB;0CACwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B;uDACqD;AACvD;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,UAAU;EACV,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,mDAAmD;AACrD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;;8BAE4B;EAC5B,oBAAoB;EACpB,gEAAgE;EAChE,mEAAmE;EACnE,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;iCAEiC;AACjC;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,sCAAsC;EACtC,6BAA6B;EAC7B;;4BAE0B;EAC1B,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mCAAmC;EACnC,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;sDACsD;AACtD;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,oDAAoD;AACtD;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0EAA0E;EAC1E;4CAC0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0EAA0E;AAC5E;;AAEA;iCACiC;AACjC;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;EACvB,eAAe;EACf;;4CAE0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qEAAqE;AACrE;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,sCAAsC;EACtC,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,uCAAuC;EACvC,2BAA2B;EAC3B;;4BAE0B;EAC1B,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;kDACkD;AAClD;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,6BAA6B;EAC7B,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,OAAO;EACP,cAAc;EACd,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB;sEACoE;EACpE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,kDAAkD;AACpD;AACA,0DAA0D;AAC1D;EACE,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,wBAAwB;AAC1B;AACA,iFAAiF;AACjF;EACE,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gEAAgE;AAClE;AACA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;EACjB,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;iDAEiD;AACjD;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD,sBAAsB,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;AAC5G,uBAAuB,OAAO,oBAAoB,EAAE,EAAE,KAAK,oBAAoB,EAAE,EAAE;AACnF,qBAAqB,OAAO,oBAAoB,EAAE,EAAE,KAAK,oBAAoB,EAAE,EAAE;AACjF,uBAAuB,OAAO,UAAU,EAAE,qCAAqC,EAAE,EAAE,KAAK,UAAU,EAAE,kCAAkC,EAAE,EAAE;AAC1I,qBAAqB,KAAK,UAAU,EAAE,qBAAqB,EAAE,EAAE,MAAM,sBAAsB,EAAE,EAAE,OAAO,UAAU,EAAE,mBAAmB,EAAE,EAAE;;AAEzI,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qDAAqD;EACrD,qDAAqD;AACvD;AACA;EACE,WAAW;EACX,kBAAkB,EAAE,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,WAAW;EAC1D,0DAA0D;EAC1D,UAAU,EAAE,6BAA6B;AAC3C;AACA,qBAAqB,2BAA2B,EAAE,4BAA4B,EAAE;AAChF,6BAA6B,UAAU,EAAE;AACzC,0CAA0C,qBAAqB,EAAE;AACjE,0CAA0C,qBAAqB,EAAE;AACjE,0CAA0C,qBAAqB,EAAE;AACjE,0CAA0C,qBAAqB,EAAE;AACjE,gBAAgB,kCAAkC,EAAE;;AAEpD,iDAAiD;AACjD;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sDAAsD;EACtD,qDAAqD;AACvD;AACA,iCAAiC,2BAA2B,EAAE,4BAA4B,EAAE;AAC5F,uDAAuD,qBAAqB,EAAE;AAC9E,uDAAuD,qBAAqB,EAAE;AAC9E,uDAAuD,qBAAqB,EAAE;AAC9E,uDAAuD,qBAAqB,EAAE;AAC9E,uDAAuD,qBAAqB,EAAE;;AAE9E,oCAAoC;AACpC;EACE,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA,6CAA6C;AAC7C;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,sDAAsD;AACxD;;AAEA,yDAAyD;AACzD,YAAY,sDAAsD,EAAE,wBAAwB,EAAE;;AAE9F,gEAAgE;AAChE,uBAAuB,OAAO,wBAAwB,EAAE,EAAE,KAAK,mCAAmC,EAAE,EAAE;AACtG;EACE,uDAAuD;EACvD,qDAAqD;EACrD,eAAe;AACjB;AACA,0BAA0B,aAAa,EAAE;AACzC,0BAA0B,UAAU,EAAE,gBAAgB,EAAE;;AAExD,kCAAkC;AAClC,eAAe,+CAA+C,EAAE,eAAe,EAAE;AACjF,qBAAqB,qBAAqB,EAAE,qCAAqC,EAAE;;AAEnF,+CAA+C;AAC/C,gBAAgB,oDAAoD,EAAE,wBAAwB,EAAE;;AAEhG,yDAAyD;AACzD,qBAAqB,KAAK,UAAU,EAAE,EAAE,YAAY,UAAU,EAAE,EAAE;AAClE,2BAA2B,kBAAkB,EAAE,gBAAgB,EAAE;AACjE;;EAEE,WAAW;EACX,kBAAkB,EAAE,MAAM,EAAE,SAAS,EAAE,UAAU,EAAE,UAAU;EAC7D,oFAAoF;EACpF,wBAAwB;EACxB,oBAAoB;EACpB,iCAAiC;EACjC,wBAAwB;AAC1B;AACA,qBAAqB,0DAA0D,EAAE;;AAEjF,0BAA0B;AAC1B,YAAY,mDAAmD,EAAE;;AAEjE,oCAAoC;AACpC,wBAAwB,iCAAiC,EAAE;;AAE3D;;;;;iDAKiD;;AAEjD,+EAA+E;AAC/E;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,WAAW;EACb;;EAEA;;;;;;;IAOE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,gFAAgF;AAChF;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,aAAa;IACb,YAAY;IACZ,4BAA4B;IAC5B,mDAAmD;IACnD,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,iCAAiC;IACjC,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;;;iDAKiD;AACjD;EACE,gCAAgC;EAChC,oCAAoC;EACpC,sCAAsC;EACtC,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA,2EAA2E;AAC3E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,4EAA4E;AAC5E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,gCAAgC;EAChC,sCAAsC;EACtC,0BAA0B;EAC1B,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,2CAA2C;AAC7C;;AAEA,qDAAqD;AACrD;EACE,WAAW,gCAAgC,EAAE,UAAU,EAAE;EACzD,MAAM,mCAAmC,EAAE,aAAa,EAAE;AAC5D;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,WAAW,eAAe,EAAE;AAC9B;;AAEA,qDAAqD;AACrD;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C","sourcesContent":["/* ── Premium empty state (data tables / views) ── */\n@keyframes skEmptyFloat {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-5px); }\n}\n@keyframes skEmptyRing {\n  0% { transform: scale(0.85); opacity: 0.5; }\n  70% { transform: scale(1.5); opacity: 0; }\n  100% { transform: scale(1.5); opacity: 0; }\n}\n@keyframes skSparkle {\n  0%, 100% { opacity: 0; transform: scale(0.6); }\n  50% { opacity: 1; transform: scale(1); }\n}\n@keyframes skGlowPulse {\n  0%, 100% { opacity: 0.5; transform: translateX(-50%) scale(1); }\n  50% { opacity: 0.9; transform: translateX(-50%) scale(1.15); }\n}\n@keyframes skEmptySheen {\n  0%   { transform: translateX(-130%) skewX(-18deg); }\n  55%, 100% { transform: translateX(240%) skewX(-18deg); }\n}\n.sk-empty {\n  position: relative;\n  display: flex; flex-direction: column; align-items: center; justify-content: center;\n  text-align: center;\n  width: 100%; max-width: 460px;\n  margin: 44px auto;\n  padding: 54px 40px 50px; gap: 9px;\n  border-radius: 22px;\n  background:\n    radial-gradient(120% 78% at 50% -12%, var(--accent-soft), transparent 62%),\n    linear-gradient(180deg, var(--card), var(--paper-2));\n  border: 1px solid var(--accent-line);\n  box-shadow: var(--shadow-lg), inset 0 1px 0 rgba(255,255,255,0.5);\n  overflow: hidden;\n  animation: skFadeUp .55s cubic-bezier(.2,.7,.3,1) both;\n}\n/* Diagonal light sheen that periodically sweeps across the card */\n.sk-empty::after {\n  content: '';\n  position: absolute; top: 0; left: 0; width: 55%; height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.16), transparent);\n  transform: translateX(-130%) skewX(-18deg);\n  animation: skEmptySheen 6s ease-in-out 0.8s infinite;\n  pointer-events: none;\n}\n/* Soft radial glow behind the icon badge */\n.sk-empty::before {\n  content: '';\n  position: absolute; top: 26px; left: 50%; width: 200px; height: 200px;\n  transform: translateX(-50%);\n  background: radial-gradient(circle, rgba(99,102,241,0.18), rgba(99,102,241,0) 70%);\n  pointer-events: none;\n  animation: skGlowPulse 4s ease-in-out infinite;\n}\n.sk-empty-icon {\n  position: relative;\n  width: 76px; height: 76px; border-radius: 50%;\n  display: grid; place-items: center;\n  background: radial-gradient(circle at 32% 26%, var(--accent-soft), var(--accent-line));\n  border: 1px solid var(--accent-line);\n  box-shadow: 0 16px 30px -12px rgba(79,70,229,0.50), 0 4px 10px -4px rgba(79,70,229,0.30), inset 0 1px 0 rgba(255,255,255,0.7);\n  margin-bottom: 10px;\n  animation: skEmptyFloat 3.4s ease-in-out infinite;\n}\n/* Two expanding halo rings → a ripple */\n.sk-empty-icon::before,\n.sk-empty-icon::after {\n  content: '';\n  position: absolute; inset: -6px; border-radius: 50%;\n  border: 1.5px solid var(--accent);\n  animation: skEmptyRing 2.8s ease-out infinite;\n}\n.sk-empty-icon::after { animation-delay: 1.4s; }\n/* Floating sparkles around the badge */\n.sk-empty-icon > svg { position: relative; z-index: 1; }\n.sk-empty-title {\n  position: relative;\n  font-size: 19px; font-weight: var(--fw-bold); letter-spacing: -0.4px;\n  margin-top: 2px;\n  background: linear-gradient(120deg, var(--ink), var(--accent-ink));\n  -webkit-background-clip: text; background-clip: text;\n  -webkit-text-fill-color: transparent; color: var(--accent-ink);\n}\n.sk-empty-sub {\n  position: relative;\n  font-size: 13.5px; color: var(--ink-3); max-width: 360px;\n  text-align: center; line-height: 20px; margin-top: 1px;\n}\n/* Decorative sparkles */\n.sk-empty-title::before,\n.sk-empty-title::after {\n  content: '✦';\n  position: absolute; top: -34px;\n  color: var(--accent); opacity: 0;\n  font-size: 11px;\n  animation: skSparkle 2.4s ease-in-out infinite;\n  -webkit-text-fill-color: var(--accent);\n}\n.sk-empty-title::before { left: 18%; animation-delay: 0.3s; font-size: 13px; }\n.sk-empty-title::after { right: 16%; top: -52px; animation-delay: 1.1s; }\n\n/* ════════════════════════════════════════════\n   COMING SOON — premium animated placeholder card\n   ════════════════════════════════════════════ */\n@keyframes skComingIn { 0% { opacity: 0; transform: translateY(20px) scale(0.97); } 100% { opacity: 1; transform: none; } }\n@keyframes skComingFloat { 0%, 100% { transform: translateY(0) rotate(-8deg); } 50% { transform: translateY(-8px) rotate(-8deg); } }\n@keyframes skComingHalo { 0% { transform: scale(0.8); opacity: 0.55; } 70% { transform: scale(1.6); opacity: 0; } 100% { opacity: 0; } }\n@keyframes skComingGlow { 0%, 100% { opacity: 0.55; transform: translateX(-50%) scale(1); } 50% { opacity: 0.95; transform: translateX(-50%) scale(1.18); } }\n@keyframes skComingSparkle { 0%, 100% { opacity: 0; transform: scale(0.5); } 50% { opacity: 1; transform: scale(1); } }\n\n.sk-coming {\n  position: relative;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  background:\n    radial-gradient(900px 360px at 50% -10%, var(--accent-soft), transparent 70%),\n    var(--paper-2);\n  overflow: hidden;\n}\n/* Drifting aurora blobs behind the card */\n@keyframes skDrift1 { 0%, 100% { transform: translate(0, 0); } 50% { transform: translate(46px, -34px); } }\n@keyframes skDrift2 { 0%, 100% { transform: translate(0, 0); } 50% { transform: translate(-44px, 32px); } }\n.sk-coming::before, .sk-coming::after {\n  content: ''; position: absolute; border-radius: 50%; pointer-events: none;\n  filter: blur(26px);\n}\n.sk-coming::before {\n  width: 400px; height: 400px; top: -90px; left: 8%;\n  background: radial-gradient(circle, rgba(99,102,241,0.20), transparent 70%);\n  animation: skDrift1 9s ease-in-out infinite;\n}\n.sk-coming::after {\n  width: 340px; height: 340px; bottom: -70px; right: 6%;\n  background: radial-gradient(circle, rgba(14,165,233,0.16), transparent 70%);\n  animation: skDrift2 11s ease-in-out infinite;\n}\n.sk-coming-card {\n  position: relative;\n  width: 100%;\n  max-width: 520px;\n  text-align: center;\n  background: var(--card);\n  border: 1px solid var(--line);\n  border-radius: var(--r-5);\n  padding: 48px 36px 40px;\n  box-shadow: 0 24px 60px -24px rgba(16,24,40,0.28), 0 4px 14px rgba(16,24,40,0.06);\n  animation: skComingIn .6s cubic-bezier(.2,.7,.3,1) both;\n  overflow: hidden;\n}\n/* Rotating gradient border around the card */\n.sk-coming-card::before {\n  content: ''; position: absolute; inset: 0; border-radius: inherit; padding: 1.5px;\n  background: conic-gradient(from 0deg, var(--accent), #6366f1, transparent 38%, transparent 62%, var(--accent));\n  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);\n  -webkit-mask-composite: xor; mask-composite: exclude;\n  opacity: 0.55; pointer-events: none;\n  animation: skComingSpin 8s linear infinite;\n}\n.sk-coming-glow {\n  position: absolute; top: 12px; left: 50%; width: 280px; height: 280px;\n  transform: translateX(-50%);\n  background: radial-gradient(circle, rgba(99,102,241,0.20), rgba(99,102,241,0) 70%);\n  pointer-events: none;\n  animation: skComingGlow 4.2s ease-in-out infinite;\n}\n.sk-coming-icon {\n  position: relative;\n  width: 80px; height: 80px; border-radius: 22px;\n  margin: 0 auto 22px;\n  display: grid; place-items: center;\n  background: radial-gradient(circle at 30% 24%, #eef2ff, #e0e7ff);\n  border: 1px solid var(--accent-line);\n  box-shadow: 0 14px 30px -12px rgba(79,70,229,0.5), inset 0 1px 0 rgba(255,255,255,0.7);\n  animation: skComingFloat 3.6s ease-in-out infinite;\n}\n.sk-coming-icon::before,\n.sk-coming-icon::after {\n  content: ''; position: absolute; inset: -6px; border-radius: 24px;\n  border: 1.5px solid var(--accent);\n  animation: skComingHalo 2.8s ease-out infinite;\n}\n.sk-coming-icon::after { animation-delay: 1.4s; }\n.sk-coming-eyebrow {\n  font-size: 11px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase;\n  color: var(--accent); margin-bottom: 8px;\n}\n.sk-coming-title {\n  position: relative;\n  font-size: 26px; font-weight: 800; letter-spacing: -0.6px;\n  background: linear-gradient(120deg, var(--ink), var(--accent));\n  -webkit-background-clip: text; background-clip: text;\n  -webkit-text-fill-color: transparent; color: var(--accent-ink);\n}\n.sk-coming-title::before, .sk-coming-title::after {\n  content: '✦'; position: absolute; color: var(--accent);\n  -webkit-text-fill-color: var(--accent); opacity: 0; font-size: 12px;\n  animation: skComingSparkle 2.4s ease-in-out infinite;\n}\n.sk-coming-title::before { top: -16px; left: 22%; animation-delay: .2s; }\n.sk-coming-title::after { top: -26px; right: 20%; font-size: 15px; animation-delay: 1.1s; }\n.sk-coming-sub {\n  font-size: 14px; color: var(--ink-3); line-height: 21px;\n  max-width: 380px; margin: 12px auto 0;\n}\n.sk-coming-chip {\n  display: inline-block; margin-top: 8px;\n  font-size: 12.5px; font-weight: 600; color: var(--accent-ink);\n  background: var(--accent-soft); border: 1px solid var(--accent-line);\n  border-radius: 999px; padding: 7px 16px;\n}\n\n/* Light sheen sweeping across the card on entrance */\n@keyframes skComingSheen { 0% { left: -60%; } 65%, 100% { left: 150%; } }\n.sk-coming-card::after {\n  content: ''; position: absolute; top: 0; bottom: 0; left: -60%; width: 40%;\n  background: linear-gradient(105deg, transparent, rgba(99,102,241,0.10), transparent);\n  transform: skewX(-16deg); pointer-events: none;\n  animation: skComingSheen 1.8s ease .3s both;\n}\n\n/* Slowly rotating gradient ring behind the icon */\n@keyframes skComingSpin { to { transform: rotate(360deg); } }\n.sk-coming-spin {\n  position: absolute; inset: -5px; border-radius: 26px;\n  background: conic-gradient(from 0deg, transparent, var(--accent) 90deg, transparent 200deg, var(--accent) 320deg, transparent);\n  opacity: 0.35;\n  animation: skComingSpin 6s linear infinite;\n  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px));\n  mask: radial-gradient(farthest-side, transparent calc(100% - 3px), #000 calc(100% - 3px));\n}\n\n/* \"Building\" shimmer progress bar */\n@keyframes skComingShimmer { 0% { transform: translateX(-100%); } 100% { transform: translateX(320%); } }\n.sk-coming-bar {\n  position: relative; width: 180px; height: 6px; margin: 22px auto 0;\n  border-radius: 999px; background: var(--paper-3); overflow: hidden;\n}\n.sk-coming-bar-fill {\n  position: absolute; top: 0; bottom: 0; left: 0; width: 38%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, transparent, var(--accent), #6366f1, transparent);\n  animation: skComingShimmer 1.8s ease-in-out infinite;\n}\n\n/* ── Row action icon buttons (edit / delete in data tables) ── */\n.sk-row-act {\n  display: inline-grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 9px;\n  border: 1px solid var(--line);\n  background: var(--card);\n  color: var(--ink-3);\n  cursor: pointer;\n  box-shadow: var(--shadow-sm);\n  transition: background 130ms ease, color 130ms ease, border-color 130ms ease, transform 130ms ease, box-shadow 130ms ease;\n}\n.sk-row-act:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow);\n}\n.sk-row-act:active {\n  transform: translateY(0);\n  box-shadow: var(--shadow-sm);\n}\n/* Edit → indigo accent on hover */\n.sk-row-act--edit:hover {\n  background: var(--accent-soft);\n  border-color: var(--accent-line);\n  color: var(--accent);\n}\n/* Delete → danger red on hover */\n.sk-row-act--danger:hover {\n  background: var(--danger-soft);\n  border-color: var(--danger-line);\n  color: var(--danger);\n}\n/* ── Dialog field labels (icon-led) ── */\n.sk-dlg-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 7px;\n  font-size: 12px;\n  font-weight: var(--fw-semibold);\n  color: var(--ink-2);\n}\n/* ── Dialog text inputs (edit cards) ── */\n.sk-dlg-input {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid var(--line-strong);\n  border-radius: var(--r-3);\n  padding: 9px 12px;\n  font-size: var(--fs-md);\n  color: var(--ink);\n  background: var(--card);\n  outline: none;\n  box-shadow: inset 0 1px 2px rgba(16,24,40,0.04);\n}\n\n/* ── Premium focus on bordered inputs (modals/forms). No box-shadow ring so\n   borderless inputs like the search field don't get a \"box inside a box\". ── */\ninput:focus,\ntextarea:focus {\n  border-color: var(--accent) !important;\n}\n\n/* ── Global premium scrollbars — visible + styled across the app ── */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: var(--line-strong, #ccccc4) transparent;\n}\n*::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n*::-webkit-scrollbar-track {\n  background: transparent;\n}\n*::-webkit-scrollbar-thumb {\n  background: var(--line-strong, #ccccc4);\n  border-radius: 999px;\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n*::-webkit-scrollbar-thumb:hover {\n  background: var(--ink-4, #9999aa);\n  background-clip: padding-box;\n}\n\n:root {\n  --font-sans: \"IBM Plex Sans\", \"Inter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  --font-mono: \"IBM Plex Mono\", ui-monospace, \"JetBrains Mono\", Menlo, monospace;\n  --fs-xs: 11px;\n  --fs-sm: 12px;\n  --fs-md: 13px;\n  --fs-lg: 15px;\n  --fs-xl: 18px;\n  --fs-2xl: 22px;\n  --fs-3xl: 28px;\n  --fw-regular: 400;\n  --fw-medium: 500;\n  --fw-semibold: 600;\n  --fw-bold: 700;\n\n  --paper: oklch(0.985 0.003 90);\n  --paper-2: oklch(0.970 0.004 90);\n  --paper-3: oklch(0.955 0.005 90);\n  --card: #ffffff;\n\n  --ink: oklch(0.20 0.010 250);\n  --ink-2: oklch(0.38 0.010 250);\n  --ink-3: oklch(0.55 0.010 250);\n  --ink-4: oklch(0.72 0.008 250);\n  --line: oklch(0.92 0.004 250);\n  --line-strong: oklch(0.85 0.005 250);\n\n  --accent: oklch(0.52 0.16 260);\n  --accent-ink: oklch(0.35 0.14 260);\n  --accent-soft: oklch(0.96 0.03 260);\n  --accent-line: oklch(0.86 0.06 260);\n\n  --info: oklch(0.55 0.15 250);\n  --info-soft: oklch(0.96 0.04 250);\n  --info-line: color-mix(in oklab, var(--info) 30%, var(--line));\n\n  --success: oklch(0.50 0.14 150);\n  --success-soft: oklch(0.95 0.05 150);\n  --success-line: color-mix(in oklab, var(--success) 30%, var(--line));\n\n  --warn: oklch(0.62 0.13 60);\n  --warn-soft: oklch(0.96 0.06 80);\n  --warn-line: color-mix(in oklab, var(--warn) 30%, var(--line));\n\n  --danger: oklch(0.55 0.13 25);\n  --danger-soft: oklch(0.96 0.04 25);\n  --danger-line: color-mix(in oklab, var(--danger) 30%, var(--line));\n\n  --neutral: oklch(0.55 0.14 200);\n  --neutral-soft: oklch(0.96 0.04 200);\n  --neutral-line: color-mix(in oklab, var(--neutral) 30%, var(--line));\n\n  --r-1: 3px;\n  --r-2: 5px;\n  --r-3: 8px;\n  --r-4: 12px;\n  --r-5: 16px;\n  --r-full: 999px;\n\n  --shadow-sm: 0 1px 0 rgba(16, 24, 40, .04);\n  --shadow: 0 1px 2px rgba(16, 24, 40, .06), 0 4px 12px -4px rgba(16, 24, 40, .08);\n  --shadow-md: 0 2px 6px rgba(16, 24, 40, .08), 0 8px 20px -6px rgba(16, 24, 40, .10);\n  --shadow-lg: 0 4px 14px rgba(16, 24, 40, .10), 0 16px 32px -12px rgba(16, 24, 40, .14);\n  --shadow-focus: 0 0 0 3px var(--accent-soft);\n\n  --t-fast: 100ms;\n  --t-base: 180ms;\n  --ease-out: cubic-bezier(.2, .8, .2, 1);\n}\n\n/* ─── Dark mode ────────────────────────────────────────────────────────────\n   Token-only override. Every surface/text/accent variable is re-pointed so the\n   whole token-driven UI recolors with no per-component changes. Toggled via the\n   sidebar \"Appearance\" switch, which sets data-theme=\"dark\" on <html>. */\n:root[data-theme=\"dark\"] {\n  --paper:   oklch(0.17 0.012 265);\n  --paper-2: oklch(0.21 0.014 265);\n  --paper-3: oklch(0.25 0.016 265);\n  --card:    oklch(0.205 0.015 265);\n\n  --ink:   oklch(0.96 0.006 265);\n  --ink-2: oklch(0.83 0.010 265);\n  --ink-3: oklch(0.67 0.012 265);\n  --ink-4: oklch(0.54 0.012 265);\n  --line:        oklch(0.32 0.014 265);\n  --line-strong: oklch(0.42 0.016 265);\n\n  --accent:      oklch(0.72 0.15 265);\n  --accent-ink:  oklch(0.86 0.10 265);\n  --accent-soft: oklch(0.30 0.07 265);\n  --accent-line: oklch(0.44 0.09 265);\n\n  --info:      oklch(0.72 0.13 250);\n  --info-soft: oklch(0.30 0.06 250);\n\n  --success:      oklch(0.72 0.13 150);\n  --success-soft: oklch(0.30 0.06 150);\n\n  --warn:      oklch(0.80 0.12 75);\n  --warn-soft: oklch(0.32 0.06 70);\n\n  --danger:      oklch(0.72 0.14 25);\n  --danger-soft: oklch(0.32 0.07 25);\n\n  --neutral:      oklch(0.72 0.11 200);\n  --neutral-soft: oklch(0.30 0.05 200);\n\n  /* INTERNAL partition (teal) — brighten the accent, darken the soft fills. */\n  --internal:      oklch(0.72 0.11 215);\n  --internal-ink:  oklch(0.84 0.09 215);\n  --internal-soft: oklch(0.30 0.05 215);\n  --internal-mute: oklch(0.35 0.06 215);\n  --internal-line: oklch(0.44 0.07 215);\n\n  /* Shadows need black + higher alpha to read on dark surfaces. */\n  --shadow-sm: 0 1px 0 rgba(0, 0, 0, .30);\n  --shadow:    0 1px 2px rgba(0, 0, 0, .40), 0 4px 12px -4px rgba(0, 0, 0, .55);\n  --shadow-md: 0 2px 6px rgba(0, 0, 0, .45), 0 8px 20px -6px rgba(0, 0, 0, .60);\n  --shadow-lg: 0 4px 14px rgba(0, 0, 0, .50), 0 16px 32px -12px rgba(0, 0, 0, .70);\n  --shadow-focus: 0 0 0 3px var(--accent-soft);\n\n  color-scheme: dark;\n}\n\n/* Sidebar's inner light edge looks wrong on dark — neutralize it. */\n:root[data-theme=\"dark\"] .sk-sidebar {\n  box-shadow: 1px 0 0 rgba(0, 0, 0, 0.2), inset -1px 0 0 rgba(255, 255, 255, 0.03);\n}\n\n/* Smooth the recolor when toggling. */\nbody,\n.sk-sidebar,\n.sk-card,\n.sk-topbar {\n  transition: background-color var(--t-base) var(--ease-out),\n    border-color var(--t-base) var(--ease-out),\n    color var(--t-base) var(--ease-out);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: var(--font-sans);\n  font-size: var(--fs-md);\n  line-height: 1.45;\n  color: var(--ink);\n  background: var(--paper);\n  -webkit-font-smoothing: antialiased;\n}\n\nbutton {\n  font: inherit;\n  cursor: pointer;\n}\n\ninput,\nselect,\ntextarea {\n  font: inherit;\n  color: inherit;\n}\n\n.t-mono {\n  font-family: var(--font-mono);\n  font-feature-settings: \"ss01\";\n}\n\n.t-dim {\n  color: var(--ink-3);\n}\n\n.t-strong {\n  color: var(--ink);\n  font-weight: var(--fw-semibold);\n}\n\n.t-truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── Buttons ── */\n.t-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 14px;\n  border-radius: var(--r-2);\n  border: 1px solid var(--line);\n  background: var(--card);\n  color: var(--ink);\n  font-size: var(--fs-md);\n  font-weight: var(--fw-medium);\n  white-space: nowrap;\n  user-select: none;\n  transition: background var(--t-fast) var(--ease-out), border-color var(--t-fast) var(--ease-out), color var(--t-fast) var(--ease-out);\n  cursor: pointer;\n}\n\n.t-btn:hover {\n  background: var(--paper-2);\n}\n\n.t-btn:active {\n  transform: translateY(0.5px);\n}\n\n.t-btn:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n}\n\n.t-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.t-btn--primary {\n  background: var(--ink);\n  color: var(--paper);\n  border-color: var(--ink);\n}\n\n.t-btn--primary:hover {\n  background: color-mix(in oklab, var(--ink) 88%, white);\n}\n\n.t-btn--accent {\n  background: var(--accent);\n  color: #fff;\n  border-color: var(--accent);\n}\n\n.t-btn--accent:hover {\n  background: var(--accent-ink);\n  border-color: var(--accent-ink);\n}\n\n.t-btn--danger {\n  background: var(--danger);\n  color: #fff;\n  border-color: var(--danger);\n}\n\n.t-btn--ghost {\n  background: transparent;\n  border-color: transparent;\n  color: var(--ink-2);\n}\n\n.t-btn--ghost:hover {\n  background: color-mix(in oklab, var(--ink) 6%, transparent);\n  color: var(--ink);\n}\n\n.t-btn--outline {\n  background: transparent;\n}\n\n.t-btn--sm {\n  height: 26px;\n  padding: 0 10px;\n  font-size: var(--fs-sm);\n}\n\n.t-btn--xs {\n  height: 22px;\n  padding: 0 8px;\n  font-size: var(--fs-xs);\n}\n\n.t-btn--lg {\n  height: 38px;\n  padding: 0 18px;\n  font-size: var(--fs-lg);\n}\n\n.t-btn--icon {\n  padding: 0;\n  width: 32px;\n}\n\n.t-btn--icon.t-btn--sm {\n  width: 26px;\n}\n\n.t-btn--icon.t-btn--xs {\n  width: 22px;\n}\n\n/* ── Inputs ── */\n.t-input {\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 0 12px;\n  border: 1px solid var(--line);\n  background: var(--card);\n  border-radius: var(--r-2);\n  font-size: var(--fs-md);\n  color: var(--ink);\n  outline: none;\n  transition: border-color var(--t-fast), box-shadow var(--t-fast);\n}\n\n.t-input::placeholder {\n  color: var(--ink-4);\n}\n\n.t-input:hover {\n  border-color: var(--line-strong);\n}\n\n.t-input:focus {\n  border-color: var(--accent);\n  box-shadow: var(--shadow-focus);\n}\n\ntextarea.t-input {\n  height: auto;\n  padding: 8px 12px;\n  min-height: 80px;\n  resize: vertical;\n  line-height: 1.5;\n}\n\n.t-input--sm {\n  height: 28px;\n  font-size: var(--fs-sm);\n  padding: 0 10px;\n}\n\n/* ── Fields ── */\n.t-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.t-field label {\n  font-size: var(--fs-sm);\n  color: var(--ink-2);\n  font-weight: var(--fw-medium);\n}\n\n.t-field-hint {\n  font-size: var(--fs-xs);\n  color: var(--ink-3);\n}\n\n.t-field-error {\n  font-size: var(--fs-xs);\n  color: var(--danger);\n}\n\n/* ── Switch ── */\n.t-switch {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n  font-size: var(--fs-sm);\n  color: var(--ink-2);\n}\n\n.t-switch input {\n  display: none;\n}\n\n.t-switch-track {\n  width: 32px;\n  height: 18px;\n  background: var(--paper-3);\n  border: 1px solid var(--line-strong);\n  border-radius: var(--r-full);\n  position: relative;\n  transition: background var(--t-base), border-color var(--t-base);\n  flex-shrink: 0;\n}\n\n.t-switch-track::after {\n  content: \"\";\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  width: 14px;\n  height: 14px;\n  background: var(--card);\n  border-radius: 50%;\n  box-shadow: 0 1px 2px rgba(16, 24, 40, .18);\n  transition: transform var(--t-base) var(--ease-out);\n}\n\n.t-switch input:checked+.t-switch-track {\n  background: var(--accent);\n  border-color: var(--accent);\n}\n\n.t-switch input:checked+.t-switch-track::after {\n  transform: translateX(14px);\n}\n\n/* ── Cards ── */\n.t-card {\n  background: var(--card);\n  border: 1px solid var(--line);\n  border-radius: var(--r-3);\n  box-shadow: var(--shadow-sm);\n}\n\n.t-card-head {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--line);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.t-card-head h3 {\n  margin: 0;\n  font-size: var(--fs-md);\n  font-weight: var(--fw-semibold);\n}\n\n.t-card-sub {\n  color: var(--ink-3);\n  font-size: var(--fs-sm);\n}\n\n.t-card-body {\n  padding: 16px;\n}\n\n.t-card-foot {\n  padding: 12px 16px;\n  border-top: 1px solid var(--line);\n  background: var(--paper-2);\n  border-radius: 0 0 var(--r-3) var(--r-3);\n  font-size: var(--fs-sm);\n  color: var(--ink-3);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* ── Chips ── */\n.t-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 22px;\n  padding: 0 9px;\n  border-radius: var(--r-full);\n  border: 1px solid var(--line);\n  background: var(--card);\n  font-size: var(--fs-xs);\n  font-weight: var(--fw-medium);\n  color: var(--ink-2);\n  white-space: nowrap;\n}\n\n.t-chip--lg {\n  height: 26px;\n  padding: 0 12px;\n  font-size: var(--fs-sm);\n}\n\n.t-chip-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--ink-3);\n  flex-shrink: 0;\n}\n\n.t-chip--info {\n  color: var(--info);\n  background: var(--info-soft);\n  border-color: var(--info-line);\n}\n\n.t-chip--info .t-chip-dot {\n  background: var(--info);\n}\n\n.t-chip--success {\n  color: var(--success);\n  background: var(--success-soft);\n  border-color: var(--success-line);\n}\n\n.t-chip--success .t-chip-dot {\n  background: var(--success);\n}\n\n.t-chip--warn {\n  color: var(--warn);\n  background: var(--warn-soft);\n  border-color: var(--warn-line);\n}\n\n.t-chip--warn .t-chip-dot {\n  background: var(--warn);\n}\n\n.t-chip--danger {\n  color: var(--danger);\n  background: var(--danger-soft);\n  border-color: var(--danger-line);\n}\n\n.t-chip--danger .t-chip-dot {\n  background: var(--danger);\n}\n\n.t-chip--neutral {\n  color: var(--neutral);\n  background: var(--neutral-soft);\n  border-color: var(--neutral-line);\n}\n\n.t-chip--neutral .t-chip-dot {\n  background: var(--neutral);\n}\n\n.t-chip--accent {\n  color: var(--accent-ink);\n  background: var(--accent-soft);\n  border-color: var(--accent-line);\n}\n\n.t-chip--accent .t-chip-dot {\n  background: var(--accent);\n}\n\n.t-chip--solid {\n  background: var(--ink);\n  color: var(--paper);\n  border-color: var(--ink);\n}\n\n.t-chip--outline {\n  background: transparent;\n}\n\n/* ── Avatars ── */\n.t-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: inline-grid;\n  place-items: center;\n  background: var(--paper-3);\n  color: var(--ink-2);\n  font-weight: var(--fw-semibold);\n  font-size: var(--fs-sm);\n  border: 1px solid var(--line);\n  flex-shrink: 0;\n  text-transform: uppercase;\n}\n\n.t-avatar--xs {\n  width: 18px;\n  height: 18px;\n  font-size: 9px;\n}\n\n.t-avatar--sm {\n  width: 24px;\n  height: 24px;\n  font-size: 10px;\n}\n\n.t-avatar--lg {\n  width: 44px;\n  height: 44px;\n  font-size: var(--fs-lg);\n}\n\n/* ── Tabs ── */\n.t-tabs {\n  display: flex;\n  border-bottom: 1px solid var(--line);\n}\n\n.t-tab {\n  padding: 9px 14px;\n  font-size: var(--fs-md);\n  font-weight: var(--fw-medium);\n  color: var(--ink-3);\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  transition: color var(--t-fast), border-color var(--t-fast);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.t-tab:hover {\n  color: var(--ink-2);\n}\n\n.t-tab.is-active {\n  color: var(--ink);\n  border-bottom-color: var(--ink);\n}\n\n.t-tab-count {\n  margin-left: 6px;\n  font-family: var(--font-mono);\n  font-size: var(--fs-xs);\n  color: var(--ink-3);\n}\n\n/* ── Tables ── */\n.t-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: var(--fs-md);\n}\n\n.t-table thead th {\n  text-align: left;\n  font-weight: var(--fw-medium);\n  color: var(--ink-3);\n  font-size: var(--fs-xs);\n  letter-spacing: .04em;\n  text-transform: uppercase;\n  padding: 11px 14px;\n  border-bottom: 1px solid var(--line);\n  background: var(--paper-2);\n  white-space: nowrap;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.t-table tbody td {\n  padding: 14px 14px;\n  border-bottom: 1px solid var(--line);\n  vertical-align: middle;\n}\n\n.t-table tbody tr {\n  background: var(--card);\n  cursor: pointer;\n  transition: background 130ms ease, box-shadow 130ms ease;\n}\n\n.t-table tbody tr:hover {\n  background: var(--paper-2);\n  box-shadow: inset 3px 0 0 var(--accent);\n}\n\n.t-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.t-table-no-hover tbody tr {\n  cursor: default;\n}\n\n.t-table-no-hover tbody tr:hover {\n  background: var(--card);\n}\n\n/* ── Modal ── */\n.t-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(16, 24, 40, .42);\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  z-index: 1000;\n}\n\n.t-modal {\n  background: var(--card);\n  border-radius: var(--r-4);\n  box-shadow: var(--shadow-lg);\n  width: 520px;\n  max-width: 100%;\n  max-height: 90vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.t-modal-head {\n  padding: 14px 18px;\n  border-bottom: 1px solid var(--line);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.t-modal-head h2 {\n  margin: 0;\n  font-size: var(--fs-lg);\n  font-weight: var(--fw-semibold);\n}\n\n.t-modal-body {\n  padding: 18px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.t-modal-foot {\n  padding: 12px 18px;\n  border-top: 1px solid var(--line);\n  background: var(--paper-2);\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n/* ── Alerts ── */\n.t-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 14px;\n  border: 1px solid var(--line);\n  background: var(--paper-2);\n  border-radius: var(--r-3);\n  font-size: var(--fs-md);\n  color: var(--ink-2);\n}\n\n.t-alert--success {\n  border-color: var(--success-line);\n  background: var(--success-soft);\n  color: var(--success);\n}\n\n.t-alert--warn {\n  border-color: var(--warn-line);\n  background: var(--warn-soft);\n  color: var(--warn);\n}\n\n.t-alert--danger {\n  border-color: var(--danger-line);\n  background: var(--danger-soft);\n  color: var(--danger);\n}\n\n.t-alert--info {\n  border-color: var(--info-line);\n  background: var(--info-soft);\n  color: var(--info);\n}\n\n.t-alert strong {\n  font-weight: var(--fw-semibold);\n}\n\n.t-alert-body {\n  flex: 1;\n}\n\n.t-alert-title {\n  font-weight: var(--fw-semibold);\n  margin-bottom: 2px;\n}\n\n.t-kbd {\n  display: inline-block;\n  font-family: var(--font-mono);\n  font-size: var(--fs-xs);\n  color: var(--ink-3);\n  border: 1px solid var(--line);\n  border-radius: 3px;\n  padding: 1px 5px;\n  background: var(--paper);\n}\n\n.t-divider {\n  height: 1px;\n  background: var(--line);\n  margin: 12px 0;\n}\n\n/* ── Layout helpers ── */\n.t-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.t-col {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.t-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.t-cluster {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.t-spread {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.t-grow {\n  flex: 1;\n  min-width: 0;\n}\n\n/* ════════════════════════════════════════════\n   APP SHELL\n   ════════════════════════════════════════════ */\n.sk-app {\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  background: var(--paper);\n}\n\n/*\n * SKTICK-DB-001 §2.4 — the assignment-only chrome.\n *\n * A principal with zero space memberships (a franchise outlet manager) gets no\n * sidebar and no top bar, because both carry the space switcher, space names\n * and space-scoped counts. With the sidebar gone the main column simply takes\n * the full width.\n *\n * These users open the console on a phone, so this must be comfortable at\n * mobile width — it is the one surface that may not assume a wide viewport.\n */\n.sk-app--bare {\n  display: block;\n  overflow: auto;\n}\n.sk-app--bare .sk-main {\n  width: 100%;\n  max-width: 100%;\n}\n.sk-app--bare .sk-content {\n  padding: 0;\n}\n\n.sk-sidebar {\n  width: 240px;\n  flex-shrink: 0;\n  background:\n    radial-gradient(130% 32% at 0% 0%, var(--accent-soft), transparent 60%),\n    linear-gradient(180deg, var(--card) 0%, var(--paper) 100%);\n  border-right: 1px solid var(--line);\n  box-shadow: 1px 0 0 rgba(0, 0, 0, 0.01), inset -1px 0 0 rgba(255, 255, 255, 0.4);\n  display: flex;\n  flex-direction: column;\n  padding: 14px 12px 0;\n  overflow: hidden;\n}\n\n.sk-sidebar-ws-btn {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 8px 12px;\n  border-bottom: 1px solid var(--line);\n  margin-bottom: 4px;\n  background: none;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n}\n\n.sk-sidebar-ws-logo {\n  width: 38px;\n  height: 38px;\n  border-radius: var(--r-3);\n  display: grid;\n  place-items: center;\n  background: linear-gradient(140deg, #2b2b48 0%, #16162a 100%);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  flex-shrink: 0;\n  box-shadow: 0 4px 12px -4px rgba(18, 18, 38, 0.5),\n    inset 0 1px 0 rgba(255, 255, 255, 0.08);\n  transition: transform var(--t-base) var(--ease-out),\n    box-shadow var(--t-base) var(--ease-out);\n}\n\n.sk-sidebar-ws-btn:hover .sk-sidebar-ws-logo {\n  transform: translateY(-1px);\n  box-shadow: 0 9px 20px -6px rgba(18, 18, 38, 0.55),\n    inset 0 1px 0 rgba(255, 255, 255, 0.12);\n}\n\n.sk-sidebar-ws-name {\n  font-size: var(--fs-lg);\n  font-weight: var(--fw-semibold);\n  color: var(--ink);\n  line-height: 1.3;\n}\n\n.sk-sidebar-ws-sub {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  color: var(--ink);\n}\n\n.sk-nav-scroll {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-bottom: 8px;\n}\n\n.sk-nav-scroll::-webkit-scrollbar {\n  width: 0;\n}\n\n.sk-nav-group {\n  margin-top: 22px;\n}\n\n.sk-nav-group:first-child {\n  margin-top: 6px;\n}\n\n.sk-nav-group-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color: var(--ink-4);\n  text-transform: uppercase;\n  padding: 0 10px 8px;\n  display: block;\n}\n\n.sk-nav-link {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 8px 10px;\n  border-radius: var(--r-2);\n  font-size: var(--fs-md);\n  font-weight: var(--fw-medium);\n  color: var(--ink-2);\n  background: none;\n  border: none;\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  transition: background var(--t-fast) var(--ease-out),\n    color var(--t-fast) var(--ease-out);\n}\n\n/* Active accent rail — slides in from nothing to a tidy pill on the left edge. */\n.sk-nav-link::before {\n  content: \"\";\n  position: absolute;\n  left: 1px;\n  top: 50%;\n  width: 3px;\n  height: 0;\n  border-radius: 3px;\n  background: var(--accent);\n  transform: translateY(-50%);\n  transition: height var(--t-base) var(--ease-out);\n}\n\n.sk-nav-link:hover {\n  background: var(--paper-2);\n  color: var(--ink);\n}\n\n.sk-nav-link.is-active {\n  background: var(--accent-soft);\n  color: var(--accent-ink);\n  font-weight: var(--fw-semibold);\n}\n\n.sk-nav-link.is-active::before {\n  height: 18px;\n}\n\n.sk-nav-link-icon {\n  display: flex;\n  align-items: center;\n  opacity: 0.55;\n  transition: opacity var(--t-fast) var(--ease-out),\n    color var(--t-fast) var(--ease-out);\n}\n\n.sk-nav-link:hover .sk-nav-link-icon {\n  opacity: 0.8;\n}\n\n.sk-nav-link.is-active .sk-nav-link-icon {\n  opacity: 1;\n  color: var(--accent);\n}\n\n.sk-nav-link-label {\n  flex: 1;\n}\n\n.sk-nav-badge {\n  font-size: 10.5px;\n  font-weight: 700;\n  background: var(--paper-3);\n  border-radius: 10px;\n  padding: 1px 7px;\n  min-width: 18px;\n  text-align: center;\n  color: var(--ink-3);\n  font-family: var(--font-mono);\n  transition: background var(--t-fast) var(--ease-out),\n    color var(--t-fast) var(--ease-out);\n}\n\n.sk-nav-link.is-active .sk-nav-badge {\n  background: var(--accent);\n  color: #fff;\n}\n\n.sk-nav-dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 3px;\n  flex-shrink: 0;\n  display: inline-block;\n  box-shadow: 0 1px 3px -1px rgba(0, 0, 0, 0.25),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n}\n\n.sk-space-trigger:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(18, 18, 38, 0.06),\n    0 10px 22px -10px rgba(18, 18, 38, 0.28) !important;\n}\n\n/* Dark-mode toggle pill (sits at the right of the \"Light/Dark mode\" nav row) */\n.sk-theme-toggle .sk-theme-switch {\n  position: relative;\n  width: 34px;\n  height: 18px;\n  border-radius: 999px;\n  background: var(--line-strong);\n  flex: none;\n  transition: background var(--t-base) var(--ease-out);\n}\n\n.sk-theme-toggle .sk-theme-switch.is-on {\n  background: var(--accent);\n}\n\n.sk-theme-knob {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  transition: transform var(--t-base) var(--ease-out);\n}\n\n.sk-theme-switch.is-on .sk-theme-knob {\n  transform: translateX(16px);\n}\n\n.sk-user-footer {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  /* Negative side margins cancel the sidebar's 10px padding so the bar\n     spans the full width, edge to edge. Bottom margin lifts it slightly\n     up off the bottom edge. */\n  margin: 10px -12px 0;\n  padding: 13px 16px calc(13px + env(safe-area-inset-bottom, 0px));\n  background: linear-gradient(180deg, var(--paper-2), var(--paper-3));\n  border: none;\n  border-top: 1px solid var(--line);\n  border-radius: 0;\n  flex-shrink: 0;\n  cursor: default;\n  transition: background var(--t-fast) var(--ease-out);\n}\n\n.sk-user-footer:hover {\n  background: var(--paper-3);\n}\n\n/* Premium hover card floating above the footer. Fixed positioning lets it\n   escape the sidebar's overflow clip so it can be wide enough to show the\n   full email on a single line. */\n.sk-user-tip {\n  position: fixed;\n  left: 14px;\n  bottom: 66px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 6px;\n  background: var(--card);\n  border: 1px solid var(--line);\n  border-radius: var(--r-4);\n  box-shadow: var(--shadow-lg);\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(6px) scale(0.98);\n  transform-origin: bottom left;\n  transition: opacity var(--t-base) var(--ease-out),\n    transform var(--t-base) var(--ease-out),\n    visibility var(--t-base);\n  z-index: 1200;\n  pointer-events: none;\n}\n\n.sk-user-footer:hover .sk-user-tip {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0) scale(1);\n  pointer-events: auto;\n}\n\n/* Little caret pointing down at the footer */\n.sk-user-tip::after {\n  content: \"\";\n  position: absolute;\n  left: 30px;\n  top: 100%;\n  width: 10px;\n  height: 10px;\n  background: var(--card);\n  border-right: 1px solid var(--line);\n  border-bottom: 1px solid var(--line);\n  transform: translateY(-5px) rotate(45deg);\n}\n\n/* Invisible bridge across the gap so moving the cursor into the card\n   keeps it open (and the Log out button clickable). */\n.sk-user-tip::before {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  height: 14px;\n}\n\n.sk-user-tip-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: linear-gradient(135deg, #f97316, #db2777);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.sk-user-tip-body {\n  min-width: 0;\n}\n\n.sk-user-tip-name {\n  font-size: var(--fs-md);\n  font-weight: var(--fw-semibold);\n  color: var(--ink);\n  letter-spacing: 0.1px;\n}\n\n.sk-user-tip-email {\n  font-size: var(--fs-sm);\n  font-weight: var(--fw-medium);\n  color: var(--ink-3);\n  margin-top: 2px;\n  white-space: nowrap;\n}\n\n/* Shared hover-card internals (used by footer + top-bar tips) */\n.sk-tip-head {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 8px 8px 9px;\n}\n\n.sk-tip-logout {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  width: 100%;\n  padding: 9px 10px;\n  border: none;\n  background: none;\n  border-radius: var(--r-2);\n  font-size: var(--fs-md);\n  font-weight: var(--fw-medium);\n  color: var(--danger);\n  text-align: left;\n  cursor: pointer;\n  transition: background var(--t-fast) var(--ease-out);\n}\n\n/* Inset divider above the Log out row */\n.sk-tip-logout::before {\n  content: \"\";\n  position: absolute;\n  top: -2px;\n  left: 8px;\n  right: 8px;\n  height: 1px;\n  background: var(--line);\n}\n\n.sk-tip-logout:hover {\n  background: var(--danger-soft);\n}\n\n.sk-user-avatar {\n  position: relative;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: linear-gradient(135deg, #f97316, #db2777);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 2px var(--card), 0 3px 8px -2px rgba(219, 39, 119, 0.45);\n  transition: transform var(--t-base) var(--ease-out),\n    box-shadow var(--t-base) var(--ease-out);\n}\n\n/* Online status dot */\n.sk-user-avatar::after {\n  content: \"\";\n  position: absolute;\n  right: -1px;\n  bottom: -1px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: var(--success);\n  border: 2px solid var(--card);\n}\n\n.sk-user-footer:hover .sk-user-avatar {\n  transform: translateY(-1px);\n  box-shadow: 0 0 0 2px var(--card), 0 6px 14px -3px rgba(219, 39, 119, 0.5);\n}\n\n/* Let the text column shrink so long emails truncate instead of\n   spilling past the card edge. */\n.sk-user-footer .t-grow {\n  min-width: 0;\n}\n\n.sk-user-name {\n  font-size: var(--fs-sm);\n  font-weight: var(--fw-semibold);\n  color: var(--ink);\n  letter-spacing: 0.1px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sk-user-role {\n  font-size: 11px;\n  font-weight: var(--fw-medium);\n  color: var(--ink-3);\n  letter-spacing: 0.1px;\n  margin-top: 1px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sk-settings-btn {\n  width: 22px;\n  height: 22px;\n  border-radius: var(--r-1);\n  display: grid;\n  place-items: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--ink-3);\n  flex-shrink: 0;\n}\n\n.sk-settings-btn:hover {\n  background: var(--paper-2);\n  color: var(--ink);\n}\n\n.sk-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.sk-topbar {\n  height: 62px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 0 18px;\n  background: var(--card);\n  border-bottom: 1px solid var(--line);\n}\n\n.sk-topbar-crumbs {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.sk-topbar-crumb {\n  font-size: var(--fs-xl);\n  font-weight: var(--fw-medium);\n  color: var(--ink-3);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.sk-topbar-crumb.is-active {\n  font-weight: var(--fw-semibold);\n  color: var(--ink);\n  cursor: default;\n}\n\n.sk-topbar-crumb-sep {\n  color: var(--ink-4);\n  font-size: var(--fs-md);\n}\n\n.sk-search-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--paper-2);\n  border: 1px solid var(--line);\n  border-radius: var(--r-2);\n  padding: 5px 10px;\n  width: 280px;\n  cursor: text;\n  color: var(--ink-3);\n  font-size: 12.5px;\n}\n\n.sk-search-bar:hover {\n  border-color: var(--line-strong);\n}\n\n.sk-bell-btn {\n  position: relative;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--ink-3);\n  flex-shrink: 0;\n}\n\n.sk-bell-btn:hover {\n  color: var(--ink);\n}\n\n.sk-bell-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  min-width: 14px;\n  height: 14px;\n  padding: 0 3px;\n  background: var(--danger);\n  border-radius: 99px;\n  display: grid;\n  place-items: center;\n  font-size: 9px;\n  font-weight: 700;\n  color: #fff;\n  border: 2px solid var(--card);\n}\n\n/* ── Top-bar user avatar + premium hover card ── */\n.sk-topbar-user {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  flex-shrink: 0;\n  padding: 4px 5px 4px 13px;\n  border: 1px solid var(--line);\n  border-radius: var(--r-full);\n  background: var(--card);\n  cursor: pointer;\n  transition: background var(--t-fast) var(--ease-out),\n    border-color var(--t-fast) var(--ease-out),\n    box-shadow var(--t-fast) var(--ease-out);\n}\n\n.sk-topbar-user:hover {\n  background: var(--paper-2);\n  border-color: var(--line-strong);\n  box-shadow: var(--shadow-sm);\n}\n\n.sk-topbar-user-name {\n  font-size: var(--fs-md);\n  font-weight: var(--fw-semibold);\n  color: var(--ink);\n  letter-spacing: 0.1px;\n  max-width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* On narrow screens, drop the text label and keep just the avatar. */\n@media (max-width: 720px) {\n  .sk-topbar-user-name {\n    display: none;\n  }\n}\n\n.sk-topbar-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: linear-gradient(135deg, #f97316, #db2777);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  cursor: pointer;\n  flex-shrink: 0;\n  box-shadow: 0 0 0 0 var(--accent-soft);\n  transition: box-shadow var(--t-fast) var(--ease-out);\n}\n\n.sk-topbar-user:hover .sk-topbar-avatar {\n  box-shadow: 0 0 0 3px var(--paper-3);\n}\n\n.sk-topbar-user-tip {\n  position: absolute;\n  top: calc(100% + 12px);\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 6px;\n  background: var(--card);\n  border: 1px solid var(--line);\n  border-radius: var(--r-4);\n  box-shadow: var(--shadow-lg);\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-6px) scale(0.98);\n  transform-origin: top right;\n  transition: opacity var(--t-base) var(--ease-out),\n    transform var(--t-base) var(--ease-out),\n    visibility var(--t-base);\n  z-index: 1200;\n  pointer-events: none;\n}\n\n.sk-topbar-user:hover .sk-topbar-user-tip {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0) scale(1);\n  pointer-events: auto;\n}\n\n/* Caret pointing up at the avatar (right side) */\n.sk-topbar-user-tip::before {\n  content: \"\";\n  position: absolute;\n  right: 13px;\n  bottom: 100%;\n  width: 10px;\n  height: 10px;\n  background: var(--card);\n  border-left: 1px solid var(--line);\n  border-top: 1px solid var(--line);\n  transform: translateY(5px) rotate(45deg);\n}\n\n/* Invisible bridge across the gap above the card so the cursor can reach\n   it to click Log out without the card closing. */\n.sk-topbar-user-tip::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  right: 0;\n  height: 14px;\n}\n\n.sk-content {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Page header ── */\n.sk-page-head {\n  padding: 24px 40px 14px;\n  background: var(--card);\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px 16px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n/* Action cluster in the header wraps neatly under the title on small screens. */\n.sk-page-head-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.sk-page-head-title {\n  font-size: 23px;\n  font-weight: var(--fw-bold);\n  color: var(--ink);\n  letter-spacing: -0.4px;\n}\n\n.sk-page-head-sub {\n  font-size: 12.5px;\n  color: var(--ink-3);\n  margin-top: 3px;\n}\n\n/* ── Filter bar ── */\n.sk-filter-bar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 40px 8px;\n  height: 44px;\n  background: var(--card);\n  flex-shrink: 0;\n  overflow-x: auto;\n}\n\n.sk-filter-bar::-webkit-scrollbar {\n  height: 0;\n}\n\n.sk-filter-divider {\n  width: 1px;\n  height: 18px;\n  background: var(--line);\n  margin: 0 8px;\n  flex-shrink: 0;\n}\n\n.sk-filter-label {\n  font-size: 12px;\n  color: var(--ink-3);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.sk-filter-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 26px;\n  padding: 0 11px;\n  border-radius: var(--r-full);\n  border: 1px solid transparent;\n  background: transparent;\n  font-size: var(--fs-sm);\n  font-weight: var(--fw-medium);\n  color: var(--ink-2);\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: background var(--t-fast), color var(--t-fast);\n}\n\n.sk-filter-chip:hover {\n  background: var(--paper-2);\n  color: var(--ink);\n}\n\n.sk-filter-chip.is-active {\n  background: var(--ink);\n  color: var(--paper);\n  border-color: var(--ink);\n}\n\n.sk-ch-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 0 8px;\n  border-radius: var(--r-2);\n  border: 1px solid transparent;\n  background: transparent;\n  font-size: var(--fs-xs);\n  font-weight: var(--fw-medium);\n  color: var(--ink-3);\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.sk-ch-chip:hover {\n  background: var(--paper-2);\n  color: var(--ink-2);\n}\n\n.sk-ch-chip.is-active {\n  background: var(--card);\n  border-color: var(--line);\n  color: var(--ink);\n}\n\n/* ── Search input (inline filter bar) ── */\n.sk-inline-search {\n  position: relative;\n  flex: 1;\n  max-width: 280px;\n}\n\n.sk-inline-search svg {\n  position: absolute;\n  left: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: var(--ink-4);\n}\n\n.sk-inline-search input {\n  width: 100%;\n  height: 28px;\n  padding: 0 10px 0 28px;\n  border: 1px solid var(--line);\n  background: var(--paper);\n  border-radius: var(--r-2);\n  font-size: var(--fs-sm);\n  color: var(--ink);\n  outline: none;\n}\n\n.sk-inline-search input:focus {\n  border-color: var(--accent);\n  box-shadow: var(--shadow-focus);\n}\n\n.sk-inline-search input::placeholder {\n  color: var(--ink-4);\n}\n\n/* ── Table wrap ── */\n.sk-table-wrap {\n  flex: 1;\n  overflow: auto;\n  background: var(--paper-2);\n  padding: 16px 40px 32px;\n}\n\n.sk-table-card {\n  background: var(--card);\n  border: 1px solid var(--line);\n  border-radius: var(--r-4);\n  width: 100%;\n  box-shadow: var(--shadow);\n  /* Horizontal scroll lives on the card so the scrollbar sits directly under\n     the rows — visible and obvious that more columns are reachable. */\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: var(--line-strong) var(--paper-2);\n}\n/* Always-visible, styled horizontal scrollbar (WebKit). */\n.sk-table-card::-webkit-scrollbar {\n  height: 11px;\n}\n.sk-table-card::-webkit-scrollbar-track {\n  background: var(--paper-2);\n  border-bottom-left-radius: var(--r-4);\n  border-bottom-right-radius: var(--r-4);\n}\n.sk-table-card::-webkit-scrollbar-thumb {\n  background: var(--line-strong);\n  border-radius: 999px;\n  border: 3px solid var(--paper-2);\n}\n.sk-table-card::-webkit-scrollbar-thumb:hover {\n  background: var(--ink-4);\n}\n/* Force the table to its natural (content) width so the card actually scrolls. */\n.sk-table-card .t-table {\n  min-width: max-content;\n}\n\n/* ── Search row above a list/table (mirrors the Inbox layout) ── */\n.sk-search-row {\n  display: flex;\n  padding: 8px 40px 12px;\n  background: var(--card);\n  flex-shrink: 0;\n}\n.sk-search-row-inner {\n  width: 100%;\n  max-width: 420px;\n}\n\n/* ── Responsive \"table → cards\" list (mobile + tablet) ── */\n.sk-card-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 12px 0 4px;\n}\n.sk-data-card {\n  background: var(--card);\n  border: 1px solid var(--line);\n  border-radius: var(--r-3);\n  box-shadow: var(--shadow-sm);\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  cursor: pointer;\n  transition: border-color var(--t-fast), background var(--t-fast);\n}\n.sk-data-card:hover {\n  border-color: var(--line-strong);\n  background: var(--paper-2);\n}\n.sk-data-card-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.sk-data-card-title {\n  font-size: var(--fs-md);\n  font-weight: var(--fw-semibold);\n  color: var(--ink);\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.sk-data-card-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: var(--fs-sm);\n}\n.sk-data-card-label {\n  color: var(--ink-3);\n  flex-shrink: 0;\n}\n.sk-data-card-value {\n  color: var(--ink);\n  min-width: 0;\n  text-align: right;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ════════════════════════════════════════════\n   REPORTS PAGE\n   ════════════════════════════════════════════ */\n.sk-reports-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 40px 28px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background: var(--paper-2);\n}\n\n.sk-range-bar {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.sk-range-btn {\n  height: 26px;\n  padding: 0 12px;\n  border-radius: var(--r-2);\n  border: 1px solid transparent;\n  background: transparent;\n  font-size: var(--fs-sm);\n  font-weight: var(--fw-medium);\n  color: var(--ink-3);\n  cursor: pointer;\n}\n\n.sk-range-btn:hover {\n  background: var(--paper-3);\n  color: var(--ink-2);\n}\n\n.sk-range-btn.is-active {\n  background: var(--card);\n  border-color: var(--line);\n  color: var(--ink);\n  box-shadow: var(--shadow-sm);\n}\n\n.sk-kpi-strip {\n  display: flex;\n  gap: 12px;\n}\n\n.sk-kpi-card {\n  flex: 1;\n  background: var(--card);\n  border: 1px solid var(--line);\n  border-radius: var(--r-3);\n  padding: 16px 18px;\n  box-shadow: var(--shadow-sm);\n}\n\n.sk-kpi-label {\n  font-size: var(--fs-xs);\n  color: var(--ink-3);\n  text-transform: uppercase;\n  letter-spacing: .05em;\n  font-weight: var(--fw-medium);\n  margin-bottom: 6px;\n}\n\n.sk-kpi-value {\n  font-size: var(--fs-2xl);\n  font-weight: var(--fw-bold);\n  color: var(--ink);\n  letter-spacing: -0.5px;\n}\n\n.sk-kpi-delta {\n  font-size: var(--fs-sm);\n  color: var(--ink-3);\n  margin-top: 4px;\n}\n\n.sk-charts-row {\n  display: flex;\n  gap: 12px;\n}\n\n.sk-charts-row>.t-card {\n  flex: 1;\n}\n\n.sk-stacked-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.sk-sb-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sk-sb-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: var(--fs-xs);\n  color: var(--ink-2);\n}\n\n.sk-sb-track {\n  height: 8px;\n  border-radius: 4px;\n  background: var(--paper-3);\n  overflow: hidden;\n}\n\n.sk-sb-fill {\n  height: 100%;\n  border-radius: 4px;\n}\n\n/* ════════════════════════════════════════════\n   REPORTS — premium entrance + chart animations\n   ════════════════════════════════════════════ */\n@keyframes skFadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: none; } }\n@keyframes skBarGrow { from { transform: scaleY(0); } to { transform: scaleY(1); } }\n@keyframes skGrowX { from { transform: scaleX(0); } to { transform: scaleX(1); } }\n@keyframes skDonutIn { from { opacity: 0; transform: rotate(-90deg) scale(0.82); } to { opacity: 1; transform: rotate(-90deg) scale(1); } }\n@keyframes skPopIn { 0% { opacity: 0; transform: scale(0.9); } 60% { transform: scale(1.03); } 100% { opacity: 1; transform: scale(1); } }\n\n/* KPI cards — fade up, staggered, with a hover lift + gradient top edge */\n.sk-kpi-card {\n  position: relative;\n  overflow: hidden;\n  border-radius: var(--r-4);\n  box-shadow: var(--shadow);\n  animation: skFadeUp .5s cubic-bezier(.2,.7,.3,1) both;\n  transition: transform .18s ease, box-shadow .18s ease;\n}\n.sk-kpi-card::before {\n  content: '';\n  position: absolute; top: 0; left: 0; right: 0; height: 3px;\n  background: linear-gradient(90deg, var(--accent), #6366f1);\n  opacity: 0; transition: opacity .18s ease;\n}\n.sk-kpi-card:hover { transform: translateY(-3px); box-shadow: var(--shadow-md); }\n.sk-kpi-card:hover::before { opacity: 1; }\n.sk-kpi-strip .sk-kpi-card:nth-child(1) { animation-delay: .03s; }\n.sk-kpi-strip .sk-kpi-card:nth-child(2) { animation-delay: .09s; }\n.sk-kpi-strip .sk-kpi-card:nth-child(3) { animation-delay: .15s; }\n.sk-kpi-strip .sk-kpi-card:nth-child(4) { animation-delay: .21s; }\n.sk-kpi-value { font-variant-numeric: tabular-nums; }\n\n/* Chart cards — fade up, staggered, hover lift */\n.sk-reports-body .t-card {\n  border-radius: var(--r-4);\n  box-shadow: var(--shadow);\n  animation: skFadeUp .55s cubic-bezier(.2,.7,.3,1) both;\n  transition: transform .18s ease, box-shadow .18s ease;\n}\n.sk-reports-body .t-card:hover { transform: translateY(-2px); box-shadow: var(--shadow-md); }\n.sk-charts-row:nth-of-type(1) > .t-card:nth-child(1) { animation-delay: .26s; }\n.sk-charts-row:nth-of-type(1) > .t-card:nth-child(2) { animation-delay: .32s; }\n.sk-charts-row:nth-of-type(2) > .t-card:nth-child(1) { animation-delay: .30s; }\n.sk-charts-row:nth-of-type(2) > .t-card:nth-child(2) { animation-delay: .36s; }\n.sk-charts-row:nth-of-type(2) > .t-card:nth-child(3) { animation-delay: .42s; }\n\n/* Stacked bars grow from the left */\n.sk-sb-fill {\n  transform-origin: left center;\n  animation: skGrowX .85s cubic-bezier(.2,.7,.3,1) both;\n}\n\n/* Bar-chart bars grow up from the baseline */\n.sk-bar-rect {\n  transform-box: fill-box;\n  transform-origin: center bottom;\n  animation: skBarGrow .7s cubic-bezier(.2,.7,.3,1) both;\n}\n\n/* Donut scales + fades in (keeps its -90° orientation) */\n.sk-donut { animation: skDonutIn .7s cubic-bezier(.2,.7,.3,1) both; transform-origin: center; }\n\n/* Donut segments DRAW in one-by-one — the headline wow moment */\n@keyframes skSegDraw { from { stroke-dasharray: 0 1200; } to { stroke-dasharray: var(--d) var(--g); } }\n.sk-seg {\n  animation: skSegDraw .95s cubic-bezier(.2,.7,.3,1) both;\n  transition: stroke-width .18s ease, opacity .18s ease;\n  cursor: pointer;\n}\n.sk-donut:hover .sk-seg { opacity: 0.45; }\n.sk-donut .sk-seg:hover { opacity: 1; stroke-width: 28; }\n\n/* Bar-chart bars react on hover */\n.sk-bar-rect { transition: opacity .15s ease, filter .15s ease; cursor: pointer; }\n.sk-bar-rect:hover { opacity: 1 !important; filter: brightness(1.1) saturate(1.1); }\n\n/* KPI value gives a tiny pop as it counts up */\n.sk-kpi-value { animation: skPopIn .6s cubic-bezier(.2,.7,.3,1) both; animation-delay: inherit; }\n\n/* Light SHEEN sweeps across each card once on entrance */\n@keyframes skSweep { 0% { left: -60%; } 70%, 100% { left: 150%; } }\n.sk-reports-body .t-card { position: relative; overflow: hidden; }\n.sk-kpi-card::after,\n.sk-reports-body .t-card::after {\n  content: '';\n  position: absolute; top: 0; bottom: 0; left: -60%; width: 38%;\n  background: linear-gradient(105deg, transparent, rgba(99,102,241,0.10), transparent);\n  transform: skewX(-16deg);\n  pointer-events: none;\n  animation: skSweep 1.5s ease both;\n  animation-delay: inherit;\n}\n.sk-kpi-card:hover { box-shadow: var(--shadow-md), 0 0 0 1px var(--accent-line); }\n\n/* Donut gets soft depth */\n.sk-donut { filter: drop-shadow(0 6px 14px rgba(16,24,40,0.10)); }\n\n/* Legend dots gently pulse-pop in */\n.sk-donut + div > div { animation: skFadeUp .5s ease both; }\n\n/* ════════════════════════════════════════════\n   RESPONSIVE\n   Breakpoints are kept identical to src/theme/responsive.ts so the CSS web UI\n   and the React-Native screens switch layouts at exactly the same widths:\n     desktop ≥ 1200px · tablet 768–1199px · mobile < 768px\n   ════════════════════════════════════════════ */\n\n/* Mobile-only menu trigger + drawer backdrop (hidden until the mobile query) */\n.sk-hamburger {\n  display: none;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--r-2);\n  border: 1px solid var(--line);\n  background: var(--card);\n  place-items: center;\n  color: var(--ink-2);\n  flex-shrink: 0;\n  margin-right: 2px;\n}\n\n.sk-hamburger:hover {\n  background: var(--paper-2);\n  color: var(--ink);\n}\n\n.sk-nav-backdrop {\n  display: none;\n}\n\n/* Tablet + mobile: a compact search pill, KPI cards wrap */\n@media (max-width: 1199px) {\n  .sk-search-bar {\n    width: 44px;\n  }\n\n  .sk-search-bar span {\n    display: none;\n  }\n\n  .sk-kpi-strip {\n    flex-wrap: wrap;\n  }\n}\n\n/* Tablet (768–1199): collapse the sidebar to an icon rail */\n@media (min-width: 768px) and (max-width: 1199px) {\n  .sk-sidebar {\n    width: 56px;\n  }\n\n  .sk-sidebar-ws-name,\n  .sk-sidebar-ws-sub,\n  .sk-nav-link-label,\n  .sk-nav-badge,\n  .sk-nav-group-label,\n  .sk-user-name,\n  .sk-user-role {\n    display: none;\n  }\n\n  .sk-nav-link {\n    justify-content: center;\n    gap: 0;\n    padding: 8px;\n  }\n\n  .sk-nav-link-icon {\n    opacity: 1;\n  }\n\n  .sk-sidebar-ws-btn {\n    justify-content: center;\n    padding: 0 0 12px;\n  }\n\n  .sk-user-footer {\n    justify-content: center;\n  }\n}\n\n/* Mobile (<768): sidebar becomes an off-canvas drawer opened by the hamburger */\n@media (max-width: 767px) {\n  .sk-hamburger {\n    display: grid;\n  }\n\n  .sk-sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    z-index: 1100;\n    width: 256px;\n    transform: translateX(-100%);\n    transition: transform var(--t-base) var(--ease-out);\n    box-shadow: var(--shadow-lg);\n  }\n\n  .sk-app.sk-nav-open .sk-sidebar {\n    transform: translateX(0);\n  }\n\n  .sk-nav-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(16, 24, 40, .42);\n    z-index: 1050;\n  }\n\n  .sk-app.sk-nav-open .sk-nav-backdrop {\n    display: block;\n  }\n\n  .sk-topbar {\n    padding: 0 14px;\n    gap: 8px;\n  }\n\n  .sk-page-head {\n    padding: 18px 20px 14px;\n  }\n\n  .sk-filter-bar {\n    padding-inline: 20px;\n  }\n\n  .sk-search-row {\n    padding-inline: 20px;\n  }\n\n  .sk-table-wrap {\n    padding: 10px 20px 24px;\n  }\n\n  .sk-reports-body {\n    padding: 20px;\n  }\n\n  .sk-kpi-card {\n    min-width: calc(50% - 8px);\n  }\n\n  .sk-charts-row {\n    flex-direction: column;\n  }\n}\n\n/* Toast entrance — slides down from the top-center stack. */\n@keyframes t-slidedown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ════════════════════════════════════════════\n   INTERNAL SPACE PARTITION (SKTICK-INTSPACE-001)\n   The PUBLIC/INTERNAL boundary must be VISIBLE everywhere an internal ticket\n   can appear. The `--internal` accent (default Teal) is deliberately NEVER the\n   customer `--accent` (indigo) so the two are never confused.\n   ════════════════════════════════════════════ */\n:root {\n  --internal: oklch(0.52 0.12 215);\n  --internal-ink: oklch(0.40 0.11 215);\n  --internal-soft: oklch(0.965 0.03 215);\n  --internal-mute: oklch(0.93 0.045 215);\n  --internal-line: oklch(0.84 0.07 215);\n}\n\n/* ── The lockup — persistent \"this is INTERNAL\" marker (pill variant) ── */\n.ilock {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  height: 22px;\n  padding: 0 9px;\n  border-radius: var(--r-full);\n  background: var(--internal);\n  color: #fff;\n  font-size: var(--fs-xs);\n  font-weight: var(--fw-semibold);\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.ilock--lg {\n  height: 28px;\n  padding: 0 12px;\n  font-size: var(--fs-sm);\n}\n\n.ilock-key {\n  font-family: var(--font-mono);\n  font-weight: var(--fw-bold);\n  opacity: 0.85;\n}\n\n/* ── Internal-tinted chip (roles, type tag) ── */\n.t-chip--internal {\n  color: var(--internal-ink);\n  background: var(--internal-soft);\n  border-color: var(--internal-line);\n}\n\n.t-chip--internal .t-chip-dot {\n  background: var(--internal);\n}\n\n/* ── Employee requester chip (SK People) — distinct from a CRM contact ── */\n.t-emp {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  height: 22px;\n  padding: 0 9px;\n  border-radius: var(--r-full);\n  background: var(--internal-soft);\n  border: 1px solid var(--internal-line);\n  color: var(--internal-ink);\n  font-size: 12.5px;\n  font-weight: var(--fw-medium);\n  white-space: nowrap;\n}\n\n/* ── List-row internal rail — 3px inset rule on internal ticket rows ── */\n.irow-rail {\n  box-shadow: inset 3px 0 0 0 var(--internal);\n}\n\n/* ── Top-bar focus-strip inbox-zero celebration ── */\n@keyframes t-spark {\n  0%, 100% { transform: scale(1) rotate(0deg); opacity: 1; }\n  50% { transform: scale(1.18) rotate(8deg); opacity: 0.85; }\n}\n\n.t-spark {\n  animation: t-spark 1800ms var(--ease-out) infinite;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .t-spark { animation: none; }\n}\n\n/* ── Popover entrance (space switcher dropdown) ── */\n@keyframes t-slideup {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: translateY(0); }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
